import React, { Component } from 'react';
import getApiBaseUrl from '../utils/apiConfig';
import AsyncStorage from '@react-native-async-storage/async-storage';
import '../App.css';

const apiBase = getApiBaseUrl();

export class System extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAuthenticated: false,
      passwordInput: '',
      dijittoBtcAddress: '',
      dijittoLtcAddress: '',
      dijittoDogeAddress: '',
      loading: true,
      error: null,
      stores: [],
      loadingStores: false,
      savingFeeFor: null,
      storeRequests: [],
      loadingRequests: false,
      approvingRequest: null,
      denyingRequest: null,
      // Trust minimization limits state
      currentStoreIdForLimits: null,
      limitMode: 'coin_max',
      btcMaxLimit: 0.001,
      ltcMaxLimit: 0.1,
      dogeMaxLimit: 10000,
      timeMaxDays: 30,
      lastCloseoutBtc: null,
      lastCloseoutLtc: null,
      lastCloseoutDoge: null,
      savingLimitsFor: null,
      // Store management UI state
      searchTerm: '',
      expandedStores: new Set(),
      // Waitlist management UI state
      waitlistSearchTerm: '',
      expandedWaitlistRequests: new Set(),
      // Section collapse state
      collapsedSections: new Set(),
      // Employee modal state
      showEmployeesModal: false,
      selectedStoreForEmployees: null,
      employeesForSelectedStore: [],
      loadingEmployees: false,
      // Employee counts per store
      employeeCounts: {}, // { store_id: count }
      // Sales rep management state
      salesReps: [],
      loadingSalesReps: false,
      salesRepSearchTerm: '',
      expandedSalesReps: new Set(),
      editingSalesRep: null,
      salesRepForm: {
        name: '',
        email: '',
        btc_address: '',
        ltc_address: '',
        doge_address: '',
        active: true
      },
      savingSalesRep: false,
      deletingSalesRep: null,
      // Sales rep dashboard state
      dashboardData: null,
      loadingDashboard: false,
      dashboardTimeRange: '30',
      // Store sales rep assignment state
      assigningSalesRepFor: null,
      // Wallet monitoring state
      enablingMonitoringFor: null,
      monitoringAlerts: [],
      loadingAlerts: false,
      acknowledgingAlertId: null,
      deletingAlertId: null
    };

    this.handlePasswordSubmit = this.handlePasswordSubmit.bind(this);
    this.handleSaveSystemSettings = this.handleSaveSystemSettings.bind(this);
    this.fetchStores = this.fetchStores.bind(this);
    this.fetchEmployeeCounts = this.fetchEmployeeCounts.bind(this);
    this.handleFeeChange = this.handleFeeChange.bind(this);
    this.handleSaveFee = this.handleSaveFee.bind(this);
    this.handleStoreNameChange = this.handleStoreNameChange.bind(this);
    this.handleSaveStoreName = this.handleSaveStoreName.bind(this);
    this.handleStatusChange = this.handleStatusChange.bind(this);
    this.handleNotesChange = this.handleNotesChange.bind(this);
    this.handleSaveStatus = this.handleSaveStatus.bind(this);
    this.fetchStoreRequests = this.fetchStoreRequests.bind(this);
    this.handleApproveRequest = this.handleApproveRequest.bind(this);
    this.handleDenyRequest = this.handleDenyRequest.bind(this);
    this.handleResendActivation = this.handleResendActivation.bind(this);
    // Trust minimization limits bindings
    this.fetchLimitSettings = this.fetchLimitSettings.bind(this);
    this.handleLimitModeChange = this.handleLimitModeChange.bind(this);
    this.handleLimitChange = this.handleLimitChange.bind(this);
    this.handleSaveLimits = this.handleSaveLimits.bind(this);
    // Store management UI bindings
    this.toggleStoreExpanded = this.toggleStoreExpanded.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    // Waitlist management UI bindings
    this.toggleWaitlistExpanded = this.toggleWaitlistExpanded.bind(this);
    this.handleWaitlistSearchChange = this.handleWaitlistSearchChange.bind(this);
    // Section collapse bindings
    this.toggleSectionCollapsed = this.toggleSectionCollapsed.bind(this);
    // Employee modal bindings
    this.handleViewEmployees = this.handleViewEmployees.bind(this);
    this.handleCloseEmployeesModal = this.handleCloseEmployeesModal.bind(this);
    // Sales rep management bindings
    this.fetchSalesReps = this.fetchSalesReps.bind(this);
    this.fetchDashboard = this.fetchDashboard.bind(this);
    this.toggleSalesRepExpanded = this.toggleSalesRepExpanded.bind(this);
    this.handleSalesRepSearchChange = this.handleSalesRepSearchChange.bind(this);
    this.handleSalesRepFormChange = this.handleSalesRepFormChange.bind(this);
    this.handleCreateSalesRep = this.handleCreateSalesRep.bind(this);
    this.handleEditSalesRep = this.handleEditSalesRep.bind(this);
    this.handleSaveSalesRep = this.handleSaveSalesRep.bind(this);
    this.handleCancelEdit = this.handleCancelEdit.bind(this);
    this.handleDeleteSalesRep = this.handleDeleteSalesRep.bind(this);
    this.handleDashboardTimeRangeChange = this.handleDashboardTimeRangeChange.bind(this);
    this.handleAssignSalesRep = this.handleAssignSalesRep.bind(this);
    // Wallet monitoring bindings
    this.handleEnableMonitoring = this.handleEnableMonitoring.bind(this);
    this.handleDisableMonitoring = this.handleDisableMonitoring.bind(this);
    this.fetchMonitoringAlerts = this.fetchMonitoringAlerts.bind(this);
    this.handleAcknowledgeAlert = this.handleAcknowledgeAlert.bind(this);
    this.handleDeleteAlert = this.handleDeleteAlert.bind(this);
  }

  async componentDidMount() {
    // Check if already authenticated
    const authenticated = await AsyncStorage.getItem('system-authenticated');
    if (authenticated === 'true') {
      this.setState({ isAuthenticated: true });
      await Promise.all([
        this.fetchSystemSettings(),
        this.fetchStores(),
        this.fetchStoreRequests(),
        this.fetchSalesReps(),
        this.fetchDashboard(),
        this.fetchMonitoringAlerts()
      ]);
    } else {
      this.setState({ loading: false });
    }
  }

  async handlePasswordSubmit(e) {
    e.preventDefault();

    // Get owner password from AsyncStorage (default: owner123)
    const storedPassword = await AsyncStorage.getItem('owner-password') || 'owner123';

    if (this.state.passwordInput === storedPassword) {
      await AsyncStorage.setItem('system-authenticated', 'true');
      this.setState({ isAuthenticated: true, passwordInput: '' });
      await this.fetchSystemSettings();
    } else {
      alert('Incorrect password');
      this.setState({ passwordInput: '' });
    }
  }

  async fetchSystemSettings() {
    try {
      this.setState({ loading: true });

      const response = await fetch(`${apiBase}/system-settings`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const payload = await response.json();

      this.setState({
        dijittoBtcAddress: payload.settings.dogeexpress_btc_address || '',
        dijittoLtcAddress: payload.settings.dogeexpress_ltc_address || '',
        dijittoDogeAddress: payload.settings.dogeexpress_doge_address || '',
        loading: false
      });

    } catch (error) {
      console.error('Error fetching system settings:', error);
      this.setState({
        error: 'Failed to load system settings',
        loading: false
      });
    }
  }

  async handleSaveSystemSettings() {
    const password = window.prompt('Enter owner password to confirm changes:');
    const storedPassword = await AsyncStorage.getItem('owner-password') || 'owner123';

    if (password !== storedPassword) {
      alert('Incorrect password');
      return;
    }

    try {
      const response = await fetch(`${apiBase}/system-settings`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          dogeexpress_btc_address: this.state.dijittoBtcAddress,
          dogeexpress_ltc_address: this.state.dijittoLtcAddress,
          dogeexpress_doge_address: this.state.dijittoDogeAddress
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const payload = await response.json();

      if (payload.success) {
        alert('System settings updated successfully!');
      }

    } catch (error) {
      console.error('Error updating system settings:', error);
      alert(`Failed to update system settings: ${error.message}`);
    }
  }

  async fetchStores() {
    try {
      this.setState({ loadingStores: true });

      const response = await fetch(`${apiBase}/stores`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const payload = await response.json();
      const stores = payload.stores || [];

      this.setState({
        stores: stores,
        loadingStores: false
      });

      // Fetch employee counts for all stores
      this.fetchEmployeeCounts(stores);

    } catch (error) {
      console.error('Error fetching stores:', error);
      this.setState({
        loadingStores: false
      });
    }
  }

  async fetchEmployeeCounts(stores) {
    try {
      const apiUrl = await AsyncStorage.getItem('apiUrl') || getApiBaseUrl();

      // Fetch employee counts in parallel for all stores
      const countPromises = stores.map(async (store) => {
        try {
          const response = await fetch(`${apiUrl}/employees/store/${store.store_id}?active=true`);
          const data = await response.json();
          return {
            store_id: store.store_id,
            count: data.success ? (data.employees || []).length : 0
          };
        } catch (error) {
          console.error(`Error fetching employee count for store ${store.store_id}:`, error);
          return {
            store_id: store.store_id,
            count: 0
          };
        }
      });

      const counts = await Promise.all(countPromises);

      // Convert array to object { store_id: count }
      const employeeCounts = {};
      counts.forEach(({ store_id, count }) => {
        employeeCounts[store_id] = count;
      });

      this.setState({ employeeCounts });

    } catch (error) {
      console.error('Error fetching employee counts:', error);
    }
  }

  handleFeeChange(storeId, newFee) {
    // Update local state
    this.setState(prevState => ({
      stores: prevState.stores.map(store =>
        store.store_id === storeId
          ? { ...store, dijitto_fee_percentage: parseFloat(newFee) }
          : store
      )
    }));
  }

  async handleSaveFee(storeId) {
    const password = window.prompt('Enter owner password to save fee percentage:');
    const storedPassword = await AsyncStorage.getItem('owner-password') || 'owner123';

    if (password !== storedPassword) {
      alert('Incorrect password');
      return;
    }

    const store = this.state.stores.find(s => s.store_id === storeId);
    if (!store) return;

    const feeValue = parseFloat(store.dijitto_fee_percentage);

    // Validate fee percentage
    if (isNaN(feeValue) || feeValue < 1.00 || feeValue > 3.00) {
      alert('Fee percentage must be between 1.00 and 3.00');
      return;
    }

    try {
      this.setState({ savingFeeFor: storeId });

      const response = await fetch(`${apiBase}/stores/${storeId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          dijitto_fee_percentage: feeValue
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const payload = await response.json();

      if (payload.success) {
        alert(`Fee percentage updated successfully for store ${storeId}!`);
        // Refresh stores list
        await this.fetchStores();
      }

    } catch (error) {
      console.error('Error updating fee percentage:', error);
      alert(`Failed to update fee percentage: ${error.message}`);
    } finally {
      this.setState({ savingFeeFor: null });
    }
  }

  handleStoreNameChange(storeId, newName) {
    // Update local state
    this.setState(prevState => ({
      stores: prevState.stores.map(store =>
        store.store_id === storeId
          ? { ...store, store_name: newName }
          : store
      )
    }));
  }

  async handleSaveStoreName(storeId) {
    const password = window.prompt('Enter owner password to save store name:');
    const storedPassword = await AsyncStorage.getItem('owner-password') || 'owner123';

    if (password !== storedPassword) {
      alert('Incorrect password');
      return;
    }

    const store = this.state.stores.find(s => s.store_id === storeId);
    if (!store) return;

    const storeName = store.store_name || '';

    // Validate store name (optional - at least 1 character if provided)
    if (storeName.length === 0) {
      alert('Store name cannot be empty');
      return;
    }

    try {
      this.setState({ savingFeeFor: storeId });

      const response = await fetch(`${apiBase}/stores/${storeId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          store_name: storeName
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const payload = await response.json();

      if (payload.success) {
        alert(`Store name updated successfully for store ${storeId}!`);
        // Refresh stores list
        await this.fetchStores();
      }

    } catch (error) {
      console.error('Error updating store name:', error);
      alert(`Failed to update store name: ${error.message}`);
    } finally {
      this.setState({ savingFeeFor: null });
    }
  }

  handleStatusChange(storeId, newStatus) {
    // Update local state
    this.setState(prevState => ({
      stores: prevState.stores.map(store =>
        store.store_id === storeId
          ? { ...store, status: newStatus }
          : store
      )
    }));
  }

  handleNotesChange(storeId, newNotes) {
    // Update local state
    this.setState(prevState => ({
      stores: prevState.stores.map(store =>
        store.store_id === storeId
          ? { ...store, notes: newNotes }
          : store
      )
    }));
  }

  async handleSaveStatus(storeId) {
    const password = window.prompt('Enter owner password to update store status:');
    const storedPassword = await AsyncStorage.getItem('owner-password') || 'owner123';

    if (password !== storedPassword) {
      alert('Incorrect password');
      return;
    }

    const store = this.state.stores.find(s => s.store_id === storeId);
    if (!store) return;

    try {
      this.setState({ savingFeeFor: storeId });

      const response = await fetch(`${apiBase}/stores/${storeId}/status`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          status: store.status,
          notes: store.notes || ''
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const payload = await response.json();

      if (payload.success) {
        alert(`Store status updated successfully for ${storeId}!\n\nStatus: ${store.status}`);
        await this.fetchStores();
      }

    } catch (error) {
      console.error('Error updating store status:', error);
      alert(`Failed to update store status: ${error.message}`);
    } finally {
      this.setState({ savingFeeFor: null });
    }
  }

  async handleLogout() {
    await AsyncStorage.removeItem('system-authenticated');
    this.setState({
      isAuthenticated: false,
      dijittoBtcAddress: '',
      dijittoLtcAddress: '',
      dijittoDogeAddress: '',
      stores: [],
      storeRequests: []
    });
  }

  async fetchStoreRequests() {
    try {
      this.setState({ loadingRequests: true });

      const response = await fetch(`${apiBase}/store-requests?status=pending`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const payload = await response.json();

      this.setState({
        storeRequests: payload.requests || [],
        loadingRequests: false
      });

    } catch (error) {
      console.error('Error fetching store requests:', error);
      this.setState({
        loadingRequests: false
      });
    }
  }

  async handleApproveRequest(requestId, businessName) {
    const password = window.prompt(`Enter owner password to approve request for "${businessName}":`);
    const storedPassword = await AsyncStorage.getItem('owner-password') || 'owner123';

    if (password !== storedPassword) {
      alert('Incorrect password');
      return;
    }

    const reviewNotes = window.prompt('Optional: Add review notes for this approval:', '');

    try {
      this.setState({ approvingRequest: requestId });

      const response = await fetch(`${apiBase}/store-requests/${requestId}/approve`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          review_notes: reviewNotes || 'Approved by system owner'
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || errorData.error || `HTTP error! status: ${response.status}`);
      }

      const payload = await response.json();

      // Generate activation token for the new store
      const tokenResponse = await fetch(`${apiBase}/activation/generate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          storeId: payload.store_id,
          storeName: payload.store.store_name,
          email: payload.email,
          createdBy: 'system-admin'
        })
      });

      if (!tokenResponse.ok) {
        throw new Error('Failed to generate activation token');
      }

      const tokenData = await tokenResponse.json();

      // Show activation URL in a prompt so it's easily selectable
      const activationUrl = tokenData.activationUrl;

      // First alert with store info
      alert(
        `Request Approved! ✅\n\n` +
        `Store ID: ${payload.store_id}\n` +
        `Store Name: ${payload.store.store_name}\n` +
        `Email: ${payload.email}\n\n` +
        `The activation link will be shown next.\n` +
        `Select and copy the entire link to send to the retailer.`
      );

      // Then prompt with the activation URL (easily selectable)
      window.prompt(
        `Activation Link (expires in 7 days):\n\nSelect all and copy this link to send to the retailer via email, SMS, or WhatsApp:`,
        activationUrl
      );

      // Refresh both lists
      await Promise.all([
        this.fetchStoreRequests(),
        this.fetchStores()
      ]);

    } catch (error) {
      console.error('Error approving request:', error);
      alert(`Failed to approve request: ${error.message}`);
    } finally {
      this.setState({ approvingRequest: null });
    }
  }

  async handleResendActivation(storeId, storeName, email) {
    try {
      // Generate new activation token
      const response = await fetch(`${apiBase}/activation/generate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          storeId,
          storeName,
          email: email || '',
          createdBy: 'system-admin'
        })
      });

      if (!response.ok) {
        throw new Error('Failed to generate activation token');
      }

      const data = await response.json();
      const activationUrl = data.activationUrl;

      // First alert with store info
      alert(
        `New Activation Link Generated! 🔄\n\n` +
        `Store: ${storeName}\n` +
        `Store ID: ${storeId}\n\n` +
        `The activation link will be shown next.\n` +
        `Select and copy the entire link to send to the retailer.`
      );

      // Then prompt with the activation URL (easily selectable)
      window.prompt(
        `Activation Link (expires in 7 days):\n\nSelect all and copy this link:`,
        activationUrl
      );

    } catch (error) {
      console.error('Error generating activation link:', error);
      alert(`Failed to generate activation link: ${error.message}`);
    }
  }

  async handleDenyRequest(requestId, businessName) {
    const password = window.prompt(`Enter owner password to deny request for "${businessName}":`);
    const storedPassword = await AsyncStorage.getItem('owner-password') || 'owner123';

    if (password !== storedPassword) {
      alert('Incorrect password');
      return;
    }

    const reviewNotes = window.prompt('REQUIRED: Enter reason for denial:', '');

    if (!reviewNotes || reviewNotes.trim() === '') {
      alert('Denial reason is required');
      return;
    }

    try {
      this.setState({ denyingRequest: requestId });

      const response = await fetch(`${apiBase}/store-requests/${requestId}/deny`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          review_notes: reviewNotes
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || errorData.error || `HTTP error! status: ${response.status}`);
      }

      alert(`Request denied.\n\nReason: ${reviewNotes}`);

      // Refresh requests list
      await this.fetchStoreRequests();

    } catch (error) {
      console.error('Error denying request:', error);
      alert(`Failed to deny request: ${error.message}`);
    } finally {
      this.setState({ denyingRequest: null });
    }
  }

  // Trust Minimization Limits Functions
  async fetchLimitSettings(storeId) {
    try {
      const response = await fetch(`${apiBase}/stores/${storeId}/limits`);
      const data = await response.json();

      this.setState({
        currentStoreIdForLimits: storeId,
        limitMode: data.limit_mode || 'coin_max',
        btcMaxLimit: parseFloat(data.btc_max_limit) || 0.001,
        ltcMaxLimit: parseFloat(data.ltc_max_limit) || 0.1,
        dogeMaxLimit: parseFloat(data.doge_max_limit) || 10000,
        timeMaxDays: data.time_max_days || 30,
        lastCloseoutBtc: data.last_closeout_btc,
        lastCloseoutLtc: data.last_closeout_ltc,
        lastCloseoutDoge: data.last_closeout_doge
      });
    } catch (error) {
      console.error('Error fetching limit settings:', error);
    }
  }

  handleLimitModeChange(mode) {
    this.setState({ limitMode: mode });
  }

  handleLimitChange(field, value) {
    // Allow empty string for better UX when deleting
    // Only parse to number if value is not empty
    if (value === '' || value === null || value === undefined) {
      this.setState({ [field]: '' });
    } else {
      const parsed = parseFloat(value);
      this.setState({ [field]: isNaN(parsed) ? 0 : parsed });
    }
  }

  async handleSaveLimits(storeId) {
    const password = window.prompt('Enter owner password to save limit settings:');
    const storedPassword = await AsyncStorage.getItem('owner-password') || 'owner123';

    if (password !== storedPassword) {
      alert('Incorrect password');
      return;
    }

    try {
      this.setState({ savingLimitsFor: storeId });

      // Convert empty strings to 0 for API
      const btcMax = this.state.btcMaxLimit === '' ? 0 : parseFloat(this.state.btcMaxLimit) || 0;
      const ltcMax = this.state.ltcMaxLimit === '' ? 0 : parseFloat(this.state.ltcMaxLimit) || 0;
      const dogeMax = this.state.dogeMaxLimit === '' ? 0 : parseFloat(this.state.dogeMaxLimit) || 0;
      const timeDays = this.state.timeMaxDays === '' ? 0 : parseFloat(this.state.timeMaxDays) || 0;

      const response = await fetch(`${apiBase}/stores/${storeId}/limits`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          limit_mode: this.state.limitMode,
          btc_max_limit: btcMax,
          ltc_max_limit: ltcMax,
          doge_max_limit: dogeMax,
          time_max_days: timeDays
        })
      });

      const data = await response.json();

      if (data.success) {
        alert('Limit settings saved successfully!');
      } else {
        alert('Error saving limit settings: ' + (data.error || 'Unknown error'));
      }
    } catch (error) {
      console.error('Error saving limit settings:', error);
      alert('Error saving limit settings');
    } finally {
      this.setState({ savingLimitsFor: null });
    }
  }

  toggleStoreExpanded(storeId) {
    const newExpandedStores = new Set(this.state.expandedStores);
    if (newExpandedStores.has(storeId)) {
      newExpandedStores.delete(storeId);
    } else {
      newExpandedStores.add(storeId);
    }
    this.setState({ expandedStores: newExpandedStores });
  }

  handleSearchChange(e) {
    this.setState({ searchTerm: e.target.value });
  }

  toggleWaitlistExpanded(requestId) {
    const newExpandedRequests = new Set(this.state.expandedWaitlistRequests);
    if (newExpandedRequests.has(requestId)) {
      newExpandedRequests.delete(requestId);
    } else {
      newExpandedRequests.add(requestId);
    }
    this.setState({ expandedWaitlistRequests: newExpandedRequests });
  }

  handleWaitlistSearchChange(e) {
    this.setState({ waitlistSearchTerm: e.target.value });
  }

  toggleSectionCollapsed(sectionName) {
    const newCollapsedSections = new Set(this.state.collapsedSections);
    if (newCollapsedSections.has(sectionName)) {
      newCollapsedSections.delete(sectionName);
    } else {
      newCollapsedSections.add(sectionName);
    }
    this.setState({ collapsedSections: newCollapsedSections });
  }

  async handleViewEmployees(store) {
    this.setState({
      showEmployeesModal: true,
      selectedStoreForEmployees: store,
      loadingEmployees: true,
      employeesForSelectedStore: []
    });

    try {
      const apiUrl = await AsyncStorage.getItem('apiUrl') || getApiBaseUrl();
      const response = await fetch(`${apiUrl}/employees/store/${store.store_id}`);
      const data = await response.json();

      if (data.success) {
        const employees = data.employees || [];
        this.setState({
          employeesForSelectedStore: employees,
          loadingEmployees: false,
          // Update the count for this store
          employeeCounts: {
            ...this.state.employeeCounts,
            [store.store_id]: employees.length
          }
        });
      } else {
        console.error('Failed to fetch employees:', data.error);
        this.setState({
          employeesForSelectedStore: [],
          loadingEmployees: false
        });
      }
    } catch (error) {
      console.error('Error fetching employees:', error);
      this.setState({
        employeesForSelectedStore: [],
        loadingEmployees: false
      });
    }
  }

  handleCloseEmployeesModal() {
    this.setState({
      showEmployeesModal: false,
      selectedStoreForEmployees: null,
      employeesForSelectedStore: [],
      loadingEmployees: false
    });
  }

  // ============================================
  // Sales Rep Management Methods
  // ============================================

  async fetchSalesReps() {
    this.setState({ loadingSalesReps: true });
    try {
      const response = await fetch(`${apiBase}/api/sales-reps`);
      const data = await response.json();

      if (data.success) {
        console.log('✅ Sales reps fetched successfully:', data.salesReps);
        this.setState({
          salesReps: data.salesReps || [],
          loadingSalesReps: false
        }, () => {
          console.log('✅ State updated. salesReps count:', this.state.salesReps.length);
        });
      } else {
        console.error('Failed to fetch sales reps:', data.error);
        this.setState({ loadingSalesReps: false });
      }
    } catch (error) {
      console.error('Error fetching sales reps:', error);
      this.setState({ loadingSalesReps: false });
    }
  }

  async fetchDashboard() {
    this.setState({ loadingDashboard: true });
    try {
      const response = await fetch(`${apiBase}/api/commission-payouts/dashboard?timeRange=${this.state.dashboardTimeRange}`);
      const data = await response.json();

      if (data.success) {
        this.setState({
          dashboardData: data.dashboard,
          loadingDashboard: false
        });
      } else {
        console.error('Failed to fetch dashboard:', data.error);
        this.setState({ loadingDashboard: false });
      }
    } catch (error) {
      console.error('Error fetching dashboard:', error);
      this.setState({ loadingDashboard: false });
    }
  }

  toggleSalesRepExpanded(repId) {
    const newExpanded = new Set(this.state.expandedSalesReps);
    if (newExpanded.has(repId)) {
      newExpanded.delete(repId);
    } else {
      newExpanded.add(repId);
    }
    this.setState({ expandedSalesReps: newExpanded });
  }

  handleSalesRepSearchChange(e) {
    this.setState({ salesRepSearchTerm: e.target.value });
  }

  handleSalesRepFormChange(field, value) {
    this.setState({
      salesRepForm: {
        ...this.state.salesRepForm,
        [field]: value
      }
    });
  }

  handleCreateSalesRep() {
    this.setState({
      editingSalesRep: 'new',
      salesRepForm: {
        name: '',
        email: '',
        btc_address: '',
        ltc_address: '',
        doge_address: '',
        active: true
      }
    }, () => {
      // Scroll to top of sales rep section to show the create form
      setTimeout(() => {
        const salesRepSection = document.querySelector('.sales-rep-section');
        if (salesRepSection) {
          salesRepSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    });
  }

  handleEditSalesRep(rep) {
    this.setState({
      editingSalesRep: rep.id,
      salesRepForm: {
        name: rep.name || '',
        email: rep.email || '',
        btc_address: rep.btc_address || '',
        ltc_address: rep.ltc_address || '',
        doge_address: rep.doge_address || '',
        active: rep.active !== false
      }
    }, () => {
      // Scroll to top of sales rep section to show the edit form
      setTimeout(() => {
        const salesRepSection = document.querySelector('.sales-rep-section');
        if (salesRepSection) {
          salesRepSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    });
  }

  async handleSaveSalesRep() {
    const { editingSalesRep, salesRepForm } = this.state;

    // Validation
    if (!salesRepForm.name || !salesRepForm.email) {
      alert('Name and email are required');
      return;
    }

    this.setState({ savingSalesRep: true });

    try {
      const isNew = editingSalesRep === 'new';
      const url = isNew
        ? `${apiBase}/api/sales-reps`
        : `${apiBase}/api/sales-reps/${editingSalesRep}`;
      const method = isNew ? 'POST' : 'PUT';

      const response = await fetch(url, {
        method: method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(salesRepForm)
      });

      const data = await response.json();

      if (data.success) {
        alert(isNew ? 'Sales rep created successfully!' : 'Sales rep updated successfully!');
        await this.fetchSalesReps();
        this.setState({
          editingSalesRep: null,
          salesRepForm: {
            name: '',
            email: '',
            btc_address: '',
            ltc_address: '',
            doge_address: '',
            active: true
          },
          savingSalesRep: false
        });
      } else {
        alert(`Failed to save: ${data.error}`);
        this.setState({ savingSalesRep: false });
      }
    } catch (error) {
      console.error('Error saving sales rep:', error);
      alert('Error saving sales rep');
      this.setState({ savingSalesRep: false });
    }
  }

  handleCancelEdit() {
    this.setState({
      editingSalesRep: null,
      salesRepForm: {
        name: '',
        email: '',
        btc_address: '',
        ltc_address: '',
        doge_address: '',
        active: true
      }
    });
  }

  async handleDeleteSalesRep(repId) {
    if (!window.confirm('Are you sure you want to delete this sales rep? This will unassign them from all stores.')) {
      return;
    }

    this.setState({ deletingSalesRep: repId });

    try {
      const response = await fetch(`${apiBase}/api/sales-reps/${repId}`, {
        method: 'DELETE'
      });

      const data = await response.json();

      if (data.success) {
        alert('Sales rep deleted successfully!');
        await Promise.all([
          this.fetchSalesReps(),
          this.fetchStores()
        ]);
        this.setState({ deletingSalesRep: null });
      } else {
        alert(`Failed to delete: ${data.error}`);
        this.setState({ deletingSalesRep: null });
      }
    } catch (error) {
      console.error('Error deleting sales rep:', error);
      alert('Error deleting sales rep');
      this.setState({ deletingSalesRep: null });
    }
  }

  async handleDashboardTimeRangeChange(e) {
    this.setState({ dashboardTimeRange: e.target.value });
    // Fetch dashboard with new time range
    setTimeout(() => this.fetchDashboard(), 100);
  }

  async handleAssignSalesRep(storeId, salesRepId, commissionPercent) {
    console.log('🔵 handleAssignSalesRep called:', { storeId, salesRepId, commissionPercent });
    this.setState({ assigningSalesRepFor: storeId });

    try {
      const url = salesRepId
        ? `${apiBase}/stores/${storeId}/sales-rep`
        : `${apiBase}/stores/${storeId}/sales-rep/unassign`;
      const method = salesRepId ? 'POST' : 'DELETE';

      console.log('🔵 Making request:', method, url);
      console.log('🔵 Request body:', salesRepId ? {
        sales_rep_id: salesRepId,
        sales_commission_percent: commissionPercent || 50
      } : 'none');

      const response = await fetch(url, {
        method: method,
        headers: { 'Content-Type': 'application/json' },
        body: salesRepId ? JSON.stringify({
          sales_rep_id: salesRepId,
          sales_commission_percent: commissionPercent || 50,
          sales_commission_enabled: true
        }) : undefined
      });

      console.log('🔵 Response status:', response.status);
      const data = await response.json();
      console.log('🔵 Response data:', data);

      if (data.success) {
        console.log('✅ Assignment successful, fetching stores...');
        await this.fetchStores();
        this.setState({ assigningSalesRepFor: null });
      } else {
        console.error('❌ Assignment failed:', data.error);
        alert(`Failed to assign: ${data.error}`);
        this.setState({ assigningSalesRepFor: null });
      }
    } catch (error) {
      console.error('❌ Error assigning sales rep:', error);
      alert('Error assigning sales rep');
      this.setState({ assigningSalesRepFor: null });
    }
  }

  // =================================================================
  // Wallet Monitoring Methods
  // =================================================================

  async handleEnableMonitoring(storeId) {
    this.setState({ enablingMonitoringFor: storeId });

    try {
      const response = await fetch(`${apiBase}/stores/${storeId}/enable-monitoring`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });

      const data = await response.json();

      if (data.success) {
        alert(`✅ Monitoring enabled for ${storeId}!\n\nFirst check scheduled for:\n${new Date(data.first_check_at).toLocaleString()}`);
        await this.fetchStores(); // Refresh store list
      } else {
        alert(`❌ Failed to enable monitoring:\n${data.error}`);
      }
    } catch (error) {
      console.error('Error enabling monitoring:', error);
      alert('Error enabling monitoring');
    } finally {
      this.setState({ enablingMonitoringFor: null });
    }
  }

  async handleDisableMonitoring(storeId) {
    if (!window.confirm('Are you sure you want to disable monitoring for this store?')) {
      return;
    }

    this.setState({ enablingMonitoringFor: storeId });

    try {
      const response = await fetch(`${apiBase}/stores/${storeId}/disable-monitoring`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });

      const data = await response.json();

      if (data.success) {
        alert('✅ Monitoring disabled');
        await this.fetchStores(); // Refresh store list
      } else {
        alert(`❌ Failed to disable monitoring:\n${data.error}`);
      }
    } catch (error) {
      console.error('Error disabling monitoring:', error);
      alert('Error disabling monitoring');
    } finally {
      this.setState({ enablingMonitoringFor: null });
    }
  }

  async fetchMonitoringAlerts() {
    this.setState({ loadingAlerts: true });

    try {
      const response = await fetch(`${apiBase}/stores/monitoring-alerts`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });

      const data = await response.json();

      if (data.success) {
        this.setState({ monitoringAlerts: data.alerts });
      } else {
        console.error('Failed to fetch alerts:', data.error);
      }
    } catch (error) {
      console.error('Error fetching alerts:', error);
    } finally {
      this.setState({ loadingAlerts: false });
    }
  }

  async handleAcknowledgeAlert(alertId) {
    this.setState({ acknowledgingAlertId: alertId });

    try {
      const response = await fetch(`${apiBase}/stores/monitoring-alerts/${alertId}/acknowledge`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ acknowledged_by: 'system_admin' })
      });

      const data = await response.json();

      if (data.success) {
        await this.fetchMonitoringAlerts(); // Refresh alerts
      } else {
        alert(`Failed to acknowledge alert: ${data.error}`);
      }
    } catch (error) {
      console.error('Error acknowledging alert:', error);
      alert('Error acknowledging alert');
    } finally {
      this.setState({ acknowledgingAlertId: null });
    }
  }

  async handleDeleteAlert(alertId) {
    if (!window.confirm('Are you sure you want to delete this alert?')) {
      return;
    }

    this.setState({ deletingAlertId: alertId });

    try {
      const response = await fetch(`${apiBase}/stores/monitoring-alerts/${alertId}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' }
      });

      const data = await response.json();

      if (data.success) {
        await this.fetchMonitoringAlerts(); // Refresh alerts
      } else {
        alert(`Failed to delete alert: ${data.error}`);
      }
    } catch (error) {
      console.error('Error deleting alert:', error);
      alert('Error deleting alert');
    } finally {
      this.setState({ deletingAlertId: null });
    }
  }

  render() {
    if (!this.state.isAuthenticated) {
      return (
        <div className="admin-container">
          <div className="admin-header">
            <h1>System</h1>
          </div>

          <div className="admin-section">
            <h3>Authentication Required</h3>
            <p style={{ color: '#666', marginBottom: '20px' }}>
              Please enter the owner password to access system settings.
            </p>

            <form onSubmit={this.handlePasswordSubmit}>
              <div className="form-group" style={{ marginBottom: '20px' }}>
                <label htmlFor="password" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>Owner Password:</label>
                <input
                  type="password"
                  id="password"
                  value={this.state.passwordInput}
                  onChange={(e) => this.setState({ passwordInput: e.target.value })}
                  placeholder="Enter owner password"
                  autoFocus
                  style={{
                    width: '100%',
                    padding: '12px 14px',
                    border: '2px solid #e1e8ed',
                    borderRadius: '8px',
                    fontSize: '15px',
                    boxSizing: 'border-box',
                    transition: 'border-color 0.2s'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#007bff'}
                  onBlur={(e) => e.target.style.borderColor = '#e1e8ed'}
                />
              </div>
              <button type="submit" className="btn-primary" style={{ width: '100%' }}>
                Access System Settings
              </button>
            </form>

            <div style={{ marginTop: '24px', padding: '16px', background: '#f8f9fa', borderRadius: '8px' }}>
              <p style={{ margin: '0 0 8px 0', fontSize: '13px', color: '#666' }}>
                <strong>Default password:</strong> <code style={{ background: '#fff', padding: '2px 6px', borderRadius: '3px' }}>owner123</code>
              </p>
              <p style={{ margin: 0, fontSize: '13px', color: '#666' }}>
                To change: Set <code style={{ background: '#fff', padding: '2px 6px', borderRadius: '3px' }}>owner-password</code> in browser localStorage
              </p>
            </div>
          </div>

          <style jsx>{`
            .admin-container {
              max-width: 900px;
              margin: 0 auto;
              padding: 20px;
            }
            .admin-header {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 30px;
              padding-bottom: 20px;
              border-bottom: 2px solid #eee;
            }
            .admin-header h1 {
              margin: 0;
              font-size: 32px;
              color: #333;
            }
            .home-button {
              padding: 10px 24px;
              background-color: #007bff;
              color: white;
              border: none;
              border-radius: 6px;
              cursor: pointer;
              font-size: 16px;
              font-weight: 500;
              transition: background-color 0.2s;
            }
            .home-button:hover {
              background-color: #0056b3;
            }
            .admin-section {
              background: white;
              border: 1px solid #e1e8ed;
              border-radius: 12px;
              padding: 24px;
              margin-bottom: 20px;
              box-shadow: 0 2px 4px rgba(0,0,0,0.05);
            }
            .admin-section h3 {
              margin: 0 0 16px 0;
              font-size: 20px;
              color: #333;
            }
            .btn-primary {
              padding: 12px 24px;
              background-color: #007bff;
              color: white;
              border: none;
              border-radius: 8px;
              cursor: pointer;
              font-size: 15px;
              font-weight: 500;
              transition: background-color 0.2s;
            }
            .btn-primary:hover {
              background-color: #0056b3;
            }
          `}</style>
        </div>
      );
    }

    if (this.state.loading) {
      return (
        <div className="admin-container">
          <div className="admin-header">
            <h1>System</h1>
          </div>
          <div className="admin-section">
            <div style={{ textAlign: 'center', padding: '40px 20px' }}>
              <div style={{
                border: '4px solid #f3f3f3',
                borderTop: '4px solid #007bff',
                borderRadius: '50%',
                width: '50px',
                height: '50px',
                animation: 'spin 1s linear infinite',
                margin: '0 auto 20px'
              }}></div>
              <p style={{ color: '#666', fontSize: '16px' }}>Loading system settings...</p>
            </div>
          </div>
          <style jsx>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
            .admin-container {
              max-width: 900px;
              margin: 0 auto;
              padding: 20px;
            }
            .admin-header {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 30px;
              padding-bottom: 20px;
              border-bottom: 2px solid #eee;
            }
            .admin-header h1 {
              margin: 0;
              font-size: 32px;
              color: #333;
            }
            .home-button {
              padding: 10px 24px;
              background-color: #007bff;
              color: white;
              border: none;
              border-radius: 6px;
              cursor: pointer;
              font-size: 16px;
              font-weight: 500;
              transition: background-color 0.2s;
            }
            .home-button:hover {
              background-color: #0056b3;
            }
            .admin-section {
              background: white;
              border: 1px solid #e1e8ed;
              border-radius: 12px;
              padding: 24px;
              margin-bottom: 20px;
              box-shadow: 0 2px 4px rgba(0,0,0,0.05);
            }
          `}</style>
        </div>
      );
    }

    return (
      <div className="admin-container">
        <div className="admin-header">
          <h1>System</h1>
        </div>

        {this.state.error && (
          <div className="admin-section" style={{ backgroundColor: '#fee', border: '1px solid #fcc' }}>
            <p style={{ color: '#c00' }}>{this.state.error}</p>
          </div>
        )}

        {/* Monitoring Alerts Section */}
        <div className="admin-section">
          <div
            onClick={() => this.toggleSectionCollapsed('monitoringAlerts')}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              cursor: 'pointer',
              userSelect: 'none',
              marginBottom: '20px',
              padding: '12px',
              backgroundColor: '#f8f9fa',
              borderRadius: '8px',
              border: '2px solid #e1e8ed',
              transition: 'all 0.2s'
            }}
          >
            <div style={{ fontSize: '20px', color: '#666', minWidth: '24px' }}>
              {this.state.collapsedSections.has('monitoringAlerts') ? '▶' : '▼'}
            </div>
            <h3 style={{ margin: 0, flex: 1 }}>🚨 Monitoring Alerts</h3>
            {this.state.monitoringAlerts.filter(a => !a.acknowledged).length > 0 && (
              <span style={{
                padding: '4px 12px',
                borderRadius: '12px',
                backgroundColor: '#dc3545',
                color: 'white',
                fontSize: '13px',
                fontWeight: '600'
              }}>
                {this.state.monitoringAlerts.filter(a => !a.acknowledged).length} new
              </span>
            )}
          </div>

          {!this.state.collapsedSections.has('monitoringAlerts') && (
            <>
              <p style={{ color: '#666', marginBottom: '20px' }}>
                Alerts generated by the weekly wallet monitoring system. Critical alerts indicate unauthorized activity detected in store wallets.
              </p>

              {this.state.loadingAlerts ? (
                <div style={{ textAlign: 'center', padding: '40px', background: '#f8f9fa', borderRadius: '8px' }}>
                  <p style={{ color: '#999', margin: 0 }}>Loading alerts...</p>
                </div>
              ) : this.state.monitoringAlerts.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '40px', background: '#e7f3ff', borderRadius: '8px', border: '1px solid #2196F3' }}>
                  <span style={{ fontSize: '48px', marginBottom: '16px', display: 'block' }}>✅</span>
                  <p style={{ color: '#666', margin: 0, fontSize: '15px', fontWeight: '500' }}>
                    No alerts - all monitored stores are secure
                  </p>
                </div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  {this.state.monitoringAlerts.map(alert => {
                    const severityColors = {
                      critical: { bg: '#f8d7da', border: '#dc3545', text: '#721c24' },
                      warning: { bg: '#fff3cd', border: '#ffc107', text: '#856404' },
                      info: { bg: '#d1ecf1', border: '#17a2b8', text: '#0c5460' }
                    };
                    const color = severityColors[alert.severity] || severityColors.info;
                    const isAcknowledged = alert.acknowledged;

                    return (
                      <div
                        key={alert.id}
                        style={{
                          border: `2px solid ${color.border}`,
                          borderRadius: '8px',
                          background: isAcknowledged ? '#f8f9fa' : color.bg,
                          opacity: isAcknowledged ? 0.6 : 1,
                          transition: 'all 0.2s'
                        }}
                      >
                        <div style={{ padding: '16px' }}>
                          {/* Alert Header */}
                          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', marginBottom: '12px' }}>
                            <span style={{ fontSize: '24px' }}>
                              {alert.severity === 'critical' ? '🚨' : alert.severity === 'warning' ? '⚠️' : 'ℹ️'}
                            </span>
                            <div style={{ flex: 1 }}>
                              <h4 style={{ margin: '0 0 4px 0', fontSize: '15px', color: color.text, fontWeight: '600' }}>
                                {alert.title}
                              </h4>
                              <div style={{ fontSize: '12px', color: '#666', marginBottom: '8px' }}>
                                <strong>{alert.store_name}</strong> (Store ID: {alert.store_id})
                                {alert.crypto && ` • ${alert.crypto.toUpperCase()}`}
                                {alert.detected_txid && (
                                  <span style={{ display: 'block', marginTop: '2px', fontFamily: 'monospace', fontSize: '11px' }}>
                                    TX: {alert.detected_txid.substring(0, 16)}...
                                  </span>
                                )}
                              </div>
                              <p style={{ margin: '0 0 8px 0', fontSize: '13px', color: '#333' }}>
                                {alert.message}
                              </p>
                              <div style={{ fontSize: '11px', color: '#999' }}>
                                {new Date(alert.created_at).toLocaleString()}
                              </div>
                            </div>

                            {/* Severity Badge */}
                            <div style={{
                              padding: '4px 12px',
                              borderRadius: '12px',
                              fontSize: '11px',
                              fontWeight: '600',
                              textTransform: 'uppercase',
                              backgroundColor: color.border,
                              color: 'white'
                            }}>
                              {alert.severity}
                            </div>
                          </div>

                          {/* Acknowledged Status */}
                          {isAcknowledged && (
                            <div style={{
                              padding: '8px 12px',
                              background: '#d4edda',
                              borderRadius: '6px',
                              fontSize: '12px',
                              color: '#155724',
                              marginBottom: '12px'
                            }}>
                              ✓ Acknowledged by {alert.acknowledged_by} on {new Date(alert.acknowledged_at).toLocaleString()}
                            </div>
                          )}

                          {/* Action Buttons */}
                          <div style={{ display: 'flex', gap: '8px' }}>
                            {!isAcknowledged && (
                              <button
                                onClick={() => this.handleAcknowledgeAlert(alert.id)}
                                disabled={this.state.acknowledgingAlertId === alert.id}
                                style={{
                                  flex: 1,
                                  padding: '8px 16px',
                                  backgroundColor: this.state.acknowledgingAlertId === alert.id ? '#6c757d' : '#28a745',
                                  color: 'white',
                                  border: 'none',
                                  borderRadius: '6px',
                                  cursor: this.state.acknowledgingAlertId === alert.id ? 'not-allowed' : 'pointer',
                                  fontSize: '13px',
                                  fontWeight: '500'
                                }}
                              >
                                {this.state.acknowledgingAlertId === alert.id ? 'Acknowledging...' : '✓ Acknowledge'}
                              </button>
                            )}
                            <button
                              onClick={() => this.handleDeleteAlert(alert.id)}
                              disabled={this.state.deletingAlertId === alert.id}
                              style={{
                                flex: isAcknowledged ? 1 : 0,
                                padding: '8px 16px',
                                backgroundColor: this.state.deletingAlertId === alert.id ? '#6c757d' : '#dc3545',
                                color: 'white',
                                border: 'none',
                                borderRadius: '6px',
                                cursor: this.state.deletingAlertId === alert.id ? 'not-allowed' : 'pointer',
                                fontSize: '13px',
                                fontWeight: '500'
                              }}
                            >
                              {this.state.deletingAlertId === alert.id ? 'Deleting...' : '🗑️ Delete'}
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </>
          )}
        </div>

        <div className="admin-section">
          {/* Collapsible Section Header */}
          <div
            onClick={() => this.toggleSectionCollapsed('feeCollection')}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              cursor: 'pointer',
              userSelect: 'none',
              marginBottom: '20px',
              padding: '12px',
              backgroundColor: '#f8f9fa',
              borderRadius: '8px',
              border: '2px solid #e1e8ed',
              transition: 'all 0.2s'
            }}
          >
            <div style={{ fontSize: '20px', color: '#666', minWidth: '24px' }}>
              {this.state.collapsedSections.has('feeCollection') ? '▶' : '▼'}
            </div>
            <h3 style={{ margin: 0, flex: 1 }}>Ðijitto Fee Collection</h3>
          </div>

          {!this.state.collapsedSections.has('feeCollection') && (
            <>
              <p style={{ color: '#666', marginBottom: '20px' }}>
                Configure the wallet addresses where Ðijitto will receive fees from each payout.
                Fee percentages (1-3%) can be customized per store in the Store Fee Management section below.
                These addresses are used during the close out process to split funds between retailers and Ðijitto.
              </p>

              <div className="wallet-address-section">
            <div className="crypto-address-card crypto-address-doge">
              <div className="crypto-address-header">
                <div className="crypto-icon-badge crypto-icon-doge">
                  <span>Ɖ</span>
                </div>
                <div>
                  <div className="crypto-address-label">DOGE Payout Address</div>
                  <div className="crypto-address-sublabel">Dogecoin</div>
                </div>
              </div>
              <input
                type="text"
                id="doge-address"
                className="crypto-address-input"
                value={this.state.dijittoDogeAddress}
                onChange={(e) => this.setState({ dijittoDogeAddress: e.target.value })}
                placeholder="D9ZrZ7fUTQA4X1GCjWrHs5vxojzs4bHzY"
              />
            </div>

            <div className="crypto-address-card crypto-address-btc">
              <div className="crypto-address-header">
                <div className="crypto-icon-badge crypto-icon-btc">
                  <span>₿</span>
                </div>
                <div>
                  <div className="crypto-address-label">BTC Payout Address</div>
                  <div className="crypto-address-sublabel">Bitcoin</div>
                </div>
              </div>
              <input
                type="text"
                id="btc-address"
                className="crypto-address-input"
                value={this.state.dijittoBtcAddress}
                onChange={(e) => this.setState({ dijittoBtcAddress: e.target.value })}
                placeholder="15sTtWL3v42775KPtE6EZqfJv2AEufL1qD"
              />
            </div>

            <div className="crypto-address-card crypto-address-ltc">
              <div className="crypto-address-header">
                <div className="crypto-icon-badge crypto-icon-ltc">
                  <span>Ł</span>
                </div>
                <div>
                  <div className="crypto-address-label">LTC Payout Address</div>
                  <div className="crypto-address-sublabel">Litecoin</div>
                </div>
              </div>
              <input
                type="text"
                id="ltc-address"
                className="crypto-address-input"
                value={this.state.dijittoLtcAddress}
                onChange={(e) => this.setState({ dijittoLtcAddress: e.target.value })}
                placeholder="LhN4fEaJZTrdhCfbw76m4qoffFSdq3zvY"
              />
            </div>
          </div>

          <div style={{ marginTop: '30px', display: 'flex', gap: '10px' }}>
            <button
              onClick={this.handleSaveSystemSettings}
              className="btn-primary"
              style={{ flex: 1 }}
            >
              Save System Settings (Password Required)
            </button>
            <button
              onClick={async () => {
                await Promise.all([
                  this.fetchSystemSettings(),
                  this.fetchStores(),
                  this.fetchStoreRequests()
                ]);
              }}
              className="btn-secondary"
            >
              Reload All
            </button>
            <button
              onClick={() => this.handleLogout()}
              className="btn-secondary"
            >
              Logout
            </button>
          </div>
            </>
          )}
        </div>

        <div className="admin-section">
          {/* Collapsible Section Header */}
          <div
            onClick={() => this.toggleSectionCollapsed('storeManagement')}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              cursor: 'pointer',
              userSelect: 'none',
              marginBottom: '20px',
              padding: '12px',
              backgroundColor: '#f8f9fa',
              borderRadius: '8px',
              border: '2px solid #e1e8ed',
              transition: 'all 0.2s'
            }}
          >
            <div style={{ fontSize: '20px', color: '#666', minWidth: '24px' }}>
              {this.state.collapsedSections.has('storeManagement') ? '▶' : '▼'}
            </div>
            <h3 style={{ margin: 0, flex: 1 }}>Store Management</h3>
            <div style={{ fontSize: '14px', color: '#999', fontWeight: 'normal' }}>
              {this.state.stores.length} {this.state.stores.length === 1 ? 'store' : 'stores'}
            </div>
          </div>

          {!this.state.collapsedSections.has('storeManagement') && (
            <>
              <p style={{ color: '#666', marginBottom: '20px' }}>
                Configure store settings, fee percentages (1-3%), and trust limits for each retailer. Click a store to expand.
              </p>

              {/* Search Input */}
          <div style={{ marginBottom: '16px' }}>
            <input
              type="text"
              placeholder="🔍 Search stores by name or ID..."
              value={this.state.searchTerm}
              onChange={this.handleSearchChange}
              style={{
                width: '100%',
                padding: '12px 16px',
                border: '2px solid #e1e8ed',
                borderRadius: '8px',
                fontSize: '14px',
                outline: 'none',
                transition: 'border-color 0.2s'
              }}
              onFocus={(e) => e.target.style.borderColor = '#007bff'}
              onBlur={(e) => e.target.style.borderColor = '#e1e8ed'}
            />
          </div>

          {this.state.loadingStores ? (
            <div style={{ textAlign: 'center', padding: '20px' }}>
              <p style={{ color: '#999' }}>Loading stores...</p>
            </div>
          ) : this.state.stores.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '20px', background: '#f8f9fa', borderRadius: '8px' }}>
              <p style={{ color: '#999', margin: 0 }}>No stores found</p>
            </div>
          ) : (
            (() => {
              const filteredStores = this.state.stores.filter(store => {
                // Filter by search term
                if (!this.state.searchTerm) return true;
                const searchLower = this.state.searchTerm.toLowerCase();
                const storeName = (store.store_name || '').toLowerCase();
                const storeId = (store.store_id || '').toString();
                return storeName.includes(searchLower) || storeId.includes(searchLower);
              });

              if (filteredStores.length === 0) {
                return (
                  <div style={{ textAlign: 'center', padding: '40px 20px', background: '#f8f9fa', borderRadius: '8px' }}>
                    <p style={{ color: '#999', margin: 0, fontSize: '14px' }}>
                      No stores found matching "{this.state.searchTerm}"
                    </p>
                  </div>
                );
              }

              return (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  {filteredStores.map(store => {
                const feeValue = parseFloat(store.dijitto_fee_percentage || 2.50);
                const isInvalid = isNaN(feeValue) || feeValue < 1.00 || feeValue > 3.00;
                const isSaving = this.state.savingFeeFor === store.store_id;

                const statusColors = {
                  active: { bg: '#d4edda', border: '#28a745', text: '#155724' },
                  suspended: { bg: '#f8d7da', border: '#dc3545', text: '#721c24' },
                  pending: { bg: '#fff3cd', border: '#ffc107', text: '#856404' }
                };
                const statusColor = statusColors[store.status || 'active'];
                const isExpanded = this.state.expandedStores.has(store.store_id);

                return (
                  <div
                    key={store.store_id}
                    className="store-fee-card"
                    style={{
                      border: isInvalid ? '2px solid #dc3545' : '2px solid #e1e8ed',
                      borderRadius: '8px',
                      background: 'white',
                      transition: 'all 0.2s'
                    }}
                  >
                    {/* Collapsible Header */}
                    <div
                      onClick={() => this.toggleStoreExpanded(store.store_id)}
                      style={{
                        padding: '16px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        userSelect: 'none'
                      }}
                    >
                      {/* Expand/Collapse Icon */}
                      <div style={{ fontSize: '18px', color: '#666', minWidth: '20px' }}>
                        {isExpanded ? '▼' : '▶'}
                      </div>

                      {/* Status Badge */}
                      <div style={{
                        display: 'inline-flex',
                        padding: '4px 12px',
                        borderRadius: '12px',
                        fontSize: '12px',
                        fontWeight: '600',
                        backgroundColor: statusColor.bg,
                        color: statusColor.text,
                        border: `1px solid ${statusColor.border}`,
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                      }}>
                        {store.status || 'active'}
                      </div>

                      {/* Store Name and ID */}
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: '15px', fontWeight: '600', color: '#333' }}>
                          {store.store_name || 'Unnamed Store'}
                        </div>
                        <div style={{ fontSize: '13px', color: '#666', marginTop: '2px' }}>
                          Store ID: {store.store_id}
                        </div>
                      </div>

                      {/* Fee Badge */}
                      <div style={{
                        padding: '6px 12px',
                        borderRadius: '6px',
                        fontSize: '13px',
                        fontWeight: '600',
                        backgroundColor: '#f0f0f0',
                        color: '#333'
                      }}>
                        {feeValue.toFixed(2)}% fee
                      </div>
                    </div>

                    {/* Expanded Content */}
                    {isExpanded && (
                      <div style={{ padding: '0 16px 16px 16px', borderTop: '1px solid #e1e8ed' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '12px' }}>

                      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div style={{ flex: 1 }}>
                          <label style={{ fontSize: '12px', color: '#666', marginBottom: '4px', display: 'block' }}>
                            Store Name
                          </label>
                          <input
                            type="text"
                            value={store.store_name || ''}
                            onChange={(e) => this.handleStoreNameChange(store.store_id, e.target.value)}
                            placeholder="Enter store name"
                            style={{
                              width: '100%',
                              padding: '8px 12px',
                              border: '2px solid #e1e8ed',
                              borderRadius: '6px',
                              fontSize: '14px',
                              fontWeight: '500'
                            }}
                            disabled={isSaving}
                          />
                        </div>
                        <div style={{ paddingTop: '20px' }}>
                          <button
                            onClick={() => this.handleSaveStoreName(store.store_id)}
                            disabled={isSaving}
                            style={{
                              padding: '8px 16px',
                              backgroundColor: isSaving ? '#6c757d' : '#007bff',
                              color: 'white',
                              border: 'none',
                              borderRadius: '6px',
                              cursor: isSaving ? 'not-allowed' : 'pointer',
                              fontSize: '14px',
                              fontWeight: '500',
                              minWidth: '70px'
                            }}
                          >
                            {isSaving ? 'Saving...' : 'Save Name'}
                          </button>
                        </div>
                      </div>

                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px' }}>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: '13px', color: '#666', marginBottom: '8px' }}>
                            Store ID: {store.store_id}
                          </div>
                          {/* Activation Status */}
                          {store.activated_at ? (
                            <div style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              padding: '4px 10px',
                              borderRadius: '12px',
                              fontSize: '11px',
                              fontWeight: '600',
                              backgroundColor: '#d4edda',
                              color: '#155724',
                              border: '1px solid #28a745'
                            }}>
                              ✅ Activated {new Date(store.activated_at).toLocaleDateString()}
                            </div>
                          ) : (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              <div style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                padding: '4px 10px',
                                borderRadius: '12px',
                                fontSize: '11px',
                                fontWeight: '600',
                                backgroundColor: '#fff3cd',
                                color: '#856404',
                                border: '1px solid #ffc107'
                              }}>
                                ⏳ Pending Activation
                              </div>
                              <button
                                onClick={() => this.handleResendActivation(store.store_id, store.store_name, store.contact_email)}
                                style={{
                                  padding: '4px 10px',
                                  backgroundColor: '#007bff',
                                  color: 'white',
                                  border: 'none',
                                  borderRadius: '6px',
                                  cursor: 'pointer',
                                  fontSize: '11px',
                                  fontWeight: '600'
                                }}
                              >
                                🔄 Resend Link
                              </button>
                            </div>
                          )}
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                            <label style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
                              Fee %
                            </label>
                            <input
                              type="number"
                              min="1.00"
                              max="3.00"
                              step="0.01"
                              value={feeValue}
                              onChange={(e) => this.handleFeeChange(store.store_id, e.target.value)}
                              style={{
                                width: '80px',
                                padding: '8px 12px',
                                border: isInvalid ? '2px solid #dc3545' : '2px solid #e1e8ed',
                                borderRadius: '6px',
                                fontSize: '14px',
                                textAlign: 'center',
                                fontWeight: '600'
                              }}
                              disabled={isSaving}
                            />
                            {isInvalid && (
                              <span style={{ fontSize: '11px', color: '#dc3545', marginTop: '2px' }}>
                                1.00-3.00
                              </span>
                            )}
                          </div>

                          <button
                            onClick={() => this.handleSaveFee(store.store_id)}
                            disabled={isSaving || isInvalid}
                            style={{
                              padding: '8px 16px',
                              backgroundColor: isSaving ? '#6c757d' : (isInvalid ? '#ccc' : '#28a745'),
                              color: 'white',
                              border: 'none',
                              borderRadius: '6px',
                              cursor: isSaving || isInvalid ? 'not-allowed' : 'pointer',
                              fontSize: '14px',
                              fontWeight: '500',
                              minWidth: '70px'
                            }}
                          >
                            {isSaving ? 'Saving...' : 'Save Fee'}
                          </button>
                        </div>
                      </div>

                      {/* Status Management Section */}
                      <div style={{
                        marginTop: '12px',
                        paddingTop: '12px',
                        borderTop: '1px solid #e1e8ed'
                      }}>
                        <div style={{ display: 'flex', gap: '12px', marginBottom: '12px' }}>
                          <div style={{ flex: 1 }}>
                            <label style={{ fontSize: '12px', color: '#666', marginBottom: '4px', display: 'block' }}>
                              Status
                            </label>
                            <select
                              value={store.status || 'active'}
                              onChange={(e) => this.handleStatusChange(store.store_id, e.target.value)}
                              disabled={isSaving}
                              style={{
                                width: '100%',
                                padding: '8px 12px',
                                border: '2px solid #e1e8ed',
                                borderRadius: '6px',
                                fontSize: '14px',
                                backgroundColor: 'white',
                                cursor: 'pointer'
                              }}
                            >
                              <option value="active">Active</option>
                              <option value="pending">Pending</option>
                              <option value="suspended">Suspended</option>
                            </select>
                          </div>
                          <div style={{ paddingTop: '20px' }}>
                            <button
                              onClick={() => this.handleSaveStatus(store.store_id)}
                              disabled={isSaving}
                              style={{
                                padding: '8px 16px',
                                backgroundColor: isSaving ? '#6c757d' : '#ff6b35',
                                color: 'white',
                                border: 'none',
                                borderRadius: '6px',
                                cursor: isSaving ? 'not-allowed' : 'pointer',
                                fontSize: '14px',
                                fontWeight: '500',
                                minWidth: '100px'
                              }}
                            >
                              {isSaving ? 'Saving...' : 'Save Status'}
                            </button>
                          </div>
                        </div>
                        <div>
                          <label style={{ fontSize: '12px', color: '#666', marginBottom: '4px', display: 'block' }}>
                            Admin Notes
                          </label>
                          <textarea
                            value={store.notes || ''}
                            onChange={(e) => this.handleNotesChange(store.store_id, e.target.value)}
                            placeholder="Add notes about this store (e.g., reason for suspension, approval status, etc.)"
                            disabled={isSaving}
                            style={{
                              width: '100%',
                              padding: '8px 12px',
                              border: '2px solid #e1e8ed',
                              borderRadius: '6px',
                              fontSize: '13px',
                              minHeight: '60px',
                              resize: 'vertical',
                              fontFamily: 'inherit'
                            }}
                          />
                        </div>
                      </div>

                      {/* Sales Rep Assignment Section */}
                      <div style={{
                        marginTop: '12px',
                        paddingTop: '12px',
                        borderTop: '1px solid #e1e8ed'
                      }}>
                        <h4 style={{ margin: '0 0 12px 0', fontSize: '14px', color: '#333' }}>
                          💼 Sales Rep Assignment
                        </h4>
                        <p style={{ fontSize: '12px', color: '#666', marginBottom: '12px' }}>
                          Assign a sales representative to earn commissions on this store's transactions.
                        </p>

                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr auto', gap: '12px', alignItems: 'end' }}>
                          <div>
                            <label style={{ fontSize: '12px', color: '#666', marginBottom: '4px', display: 'block' }}>
                              Sales Rep
                            </label>
                            <select
                              value={store.sales_rep_id || ''}
                              onChange={(e) => {
                                const repId = e.target.value || null;
                                const commissionPercent = store.sales_commission_percent || 50;
                                this.handleAssignSalesRep(store.store_id, repId, commissionPercent);
                              }}
                              disabled={this.state.assigningSalesRepFor === store.store_id}
                              onFocus={() => {
                                console.log('🔍 Dropdown focused. salesReps:', this.state.salesReps);
                                console.log('🔍 Active reps:', this.state.salesReps.filter(rep => rep.active));
                              }}
                              style={{
                                width: '100%',
                                padding: '8px 12px',
                                border: '2px solid #e1e8ed',
                                borderRadius: '6px',
                                fontSize: '13px'
                              }}
                            >
                              <option value="">No sales rep assigned</option>
                              {this.state.salesReps
                                .filter(rep => rep.active)
                                .map(rep => (
                                  <option key={rep.id} value={rep.id}>
                                    {rep.name} ({rep.email})
                                  </option>
                                ))}
                            </select>
                          </div>

                          <div>
                            <label style={{ fontSize: '12px', color: '#666', marginBottom: '4px', display: 'block' }}>
                              Commission % (of DogeExpress fee)
                            </label>
                            <input
                              type="number"
                              min="0"
                              max="100"
                              step="1"
                              value={store.sales_commission_percent || 50}
                              onChange={(e) => {
                                const percent = Math.min(100, Math.max(0, parseInt(e.target.value) || 0));
                                if (store.sales_rep_id) {
                                  this.handleAssignSalesRep(store.store_id, store.sales_rep_id, percent);
                                }
                              }}
                              disabled={!store.sales_rep_id || this.state.assigningSalesRepFor === store.store_id}
                              style={{
                                width: '100%',
                                padding: '8px 12px',
                                border: '2px solid #e1e8ed',
                                borderRadius: '6px',
                                fontSize: '13px',
                                textAlign: 'center'
                              }}
                            />
                          </div>

                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <label style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '12px', color: '#666' }}>
                              <input
                                type="checkbox"
                                checked={store.sales_commission_enabled || false}
                                onChange={async (e) => {
                                  if (store.sales_rep_id) {
                                    const newEnabledState = e.target.checked;
                                    try {
                                      this.setState({ assigningSalesRepFor: store.store_id });

                                      const response = await fetch(`${apiBase}/stores/${store.store_id}/sales-rep`, {
                                        method: 'POST',
                                        headers: { 'Content-Type': 'application/json' },
                                        body: JSON.stringify({
                                          sales_rep_id: store.sales_rep_id,
                                          sales_commission_percent: store.sales_commission_percent || 50,
                                          sales_commission_enabled: newEnabledState
                                        })
                                      });

                                      const data = await response.json();
                                      if (data.success) {
                                        await this.fetchStores();
                                        alert(`Commission ${newEnabledState ? 'enabled' : 'disabled'} successfully!`);
                                      } else {
                                        alert(`Failed to update: ${data.error}`);
                                      }
                                    } catch (error) {
                                      console.error('Error toggling commission:', error);
                                      alert('Failed to update commission status');
                                    } finally {
                                      this.setState({ assigningSalesRepFor: null });
                                    }
                                  }
                                }}
                                disabled={!store.sales_rep_id || this.state.assigningSalesRepFor === store.store_id}
                              />
                              Enabled
                            </label>
                          </div>
                        </div>

                        {store.sales_rep_id && (
                          <div style={{
                            marginTop: '12px',
                            padding: '10px',
                            background: '#e7f3ff',
                            borderRadius: '6px',
                            fontSize: '12px',
                            color: '#666'
                          }}>
                            <strong>Commission Split:</strong> When Z-out occurs, {store.sales_commission_percent || 50}% of the DogeExpress fee will be paid to the sales rep, and {100 - (store.sales_commission_percent || 50)}% will go to DogeExpress.
                            {store.sales_rep_assigned_at && (
                              <div style={{ marginTop: '4px' }}>
                                <em>Assigned: {new Date(store.sales_rep_assigned_at).toLocaleDateString()}</em>
                              </div>
                            )}
                          </div>
                        )}

                        {this.state.assigningSalesRepFor === store.store_id && (
                          <div style={{ marginTop: '8px', fontSize: '12px', color: '#999' }}>
                            Updating assignment...
                          </div>
                        )}
                      </div>

                      {/* Wallet Monitoring Section */}
                      <div style={{
                        marginTop: '12px',
                        paddingTop: '12px',
                        borderTop: '1px solid #e1e8ed'
                      }}>
                        <h4 style={{ margin: '0 0 12px 0', fontSize: '14px', color: '#333' }}>
                          🔐 Weekly Wallet Monitoring
                        </h4>
                        <p style={{ fontSize: '12px', color: '#666', marginBottom: '12px' }}>
                          Automatically check for unauthorized wallet activity once per week. The system will scan all configured wallets and alert you if any transactions are detected that weren't processed through DogeExpress.
                        </p>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                          {/* Current Status */}
                          <div style={{
                            padding: '12px',
                            background: store.auto_monitoring_enabled ? '#e7f3ff' : '#f8f9fa',
                            borderRadius: '6px',
                            border: `1px solid ${store.auto_monitoring_enabled ? '#2196F3' : '#e1e8ed'}`
                          }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                              <span style={{ fontSize: '16px' }}>
                                {store.auto_monitoring_enabled ? '✅' : '⏸️'}
                              </span>
                              <strong style={{ fontSize: '13px' }}>
                                Status: {store.auto_monitoring_enabled ? 'Enabled' : 'Disabled'}
                              </strong>
                            </div>

                            {store.auto_monitoring_enabled && (
                              <>
                                {store.auto_monitoring_enabled_at && (
                                  <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
                                    Enabled: {new Date(store.auto_monitoring_enabled_at).toLocaleString()}
                                  </div>
                                )}
                                {store.last_auto_check_at && (
                                  <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
                                    Last check: {new Date(store.last_auto_check_at).toLocaleString()}
                                  </div>
                                )}
                                {store.next_auto_check_at && (
                                  <div style={{ fontSize: '12px', color: '#666' }}>
                                    <strong>Next check:</strong> {new Date(store.next_auto_check_at).toLocaleString()}
                                  </div>
                                )}
                              </>
                            )}

                            {!store.auto_monitoring_enabled && (
                              <div style={{ fontSize: '12px', color: '#666' }}>
                                Enable monitoring to automatically check this store's wallets weekly
                              </div>
                            )}
                          </div>

                          {/* Enable/Disable Button */}
                          {store.auto_monitoring_enabled ? (
                            <button
                              onClick={() => this.handleDisableMonitoring(store.store_id)}
                              disabled={this.state.enablingMonitoringFor === store.store_id}
                              style={{
                                padding: '10px 16px',
                                backgroundColor: this.state.enablingMonitoringFor === store.store_id ? '#6c757d' : '#dc3545',
                                color: 'white',
                                border: 'none',
                                borderRadius: '6px',
                                cursor: this.state.enablingMonitoringFor === store.store_id ? 'not-allowed' : 'pointer',
                                fontSize: '14px',
                                fontWeight: '500'
                              }}
                            >
                              {this.state.enablingMonitoringFor === store.store_id ? 'Processing...' : '🔴 Disable Monitoring'}
                            </button>
                          ) : (
                            <button
                              onClick={() => this.handleEnableMonitoring(store.store_id)}
                              disabled={this.state.enablingMonitoringFor === store.store_id}
                              style={{
                                padding: '10px 16px',
                                backgroundColor: this.state.enablingMonitoringFor === store.store_id ? '#6c757d' : '#28a745',
                                color: 'white',
                                border: 'none',
                                borderRadius: '6px',
                                cursor: this.state.enablingMonitoringFor === store.store_id ? 'not-allowed' : 'pointer',
                                fontSize: '14px',
                                fontWeight: '500'
                              }}
                            >
                              {this.state.enablingMonitoringFor === store.store_id ? 'Processing...' : '✅ Enable Monitoring'}
                            </button>
                          )}

                          {/* Info Box */}
                          <div style={{
                            padding: '10px',
                            background: '#fff3cd',
                            border: '1px solid #ffc107',
                            borderRadius: '6px',
                            fontSize: '12px',
                            color: '#856404'
                          }}>
                            <strong>How it works:</strong> When enabled, the system will check this store's wallets 7 days from now at the same time. If unauthorized activity is detected, an alert will appear at the top of this System page and the store will be automatically suspended.
                          </div>
                        </div>
                      </div>

                      {/* Trust Minimization Limits Section */}
                      <div style={{
                        marginTop: '12px',
                        paddingTop: '12px',
                        borderTop: '1px solid #e1e8ed'
                      }}>
                        <h4 style={{ margin: '0 0 12px 0', fontSize: '14px', color: '#333' }}>
                          Trust Minimization Limits
                        </h4>
                        <p style={{ fontSize: '12px', color: '#666', marginBottom: '12px' }}>
                          Configure when merchants must complete close-out flow to continue operations.
                        </p>

                        {/* Fetch limits button */}
                        {this.state.currentStoreIdForLimits !== store.store_id && (
                          <button
                            onClick={() => this.fetchLimitSettings(store.store_id)}
                            style={{
                              padding: '6px 12px',
                              backgroundColor: '#2196F3',
                              color: 'white',
                              border: 'none',
                              borderRadius: '4px',
                              cursor: 'pointer',
                              fontSize: '13px',
                              marginBottom: '12px'
                            }}
                          >
                            Load Limit Settings
                          </button>
                        )}

                        {/* Show limit settings only for currently selected store */}
                        {this.state.currentStoreIdForLimits === store.store_id && (
                          <div>
                            {/* Mode Toggle */}
                            <div style={{ marginBottom: '12px' }}>
                              <label style={{ display: 'block', marginBottom: '8px', fontSize: '13px' }}>
                                <input
                                  type="radio"
                                  name={`limit_mode_${store.store_id}`}
                                  value="coin_max"
                                  checked={this.state.limitMode === 'coin_max'}
                                  onChange={() => this.handleLimitModeChange('coin_max')}
                                />
                                {' '}Coin Maximum (per cryptocurrency)
                              </label>
                              <label style={{ display: 'block', fontSize: '13px' }}>
                                <input
                                  type="radio"
                                  name={`limit_mode_${store.store_id}`}
                                  value="time_max"
                                  checked={this.state.limitMode === 'time_max'}
                                  onChange={() => this.handleLimitModeChange('time_max')}
                                />
                                {' '}Time Maximum (days since last close out)
                              </label>
                            </div>

                            {/* Coin Maximum Mode */}
                            {this.state.limitMode === 'coin_max' && (
                              <div style={{ marginBottom: '12px', padding: '12px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                                <h5 style={{ margin: '0 0 10px 0', fontSize: '13px' }}>Coin Limits</h5>
                                <div style={{ display: 'grid', gridTemplateColumns: '100px 1fr 50px', gap: '8px', alignItems: 'center' }}>
                                  <label style={{ fontSize: '12px' }}>BTC Max:</label>
                                  <input
                                    type="number"
                                    step="0.00000001"
                                    value={this.state.btcMaxLimit}
                                    onChange={(e) => this.handleLimitChange('btcMaxLimit', e.target.value)}
                                    style={{ padding: '5px', fontSize: '12px', width: '100%' }}
                                  />
                                  <span style={{ fontSize: '11px', color: '#666' }}>BTC</span>

                                  <label style={{ fontSize: '12px' }}>LTC Max:</label>
                                  <input
                                    type="number"
                                    step="0.00000001"
                                    value={this.state.ltcMaxLimit}
                                    onChange={(e) => this.handleLimitChange('ltcMaxLimit', e.target.value)}
                                    style={{ padding: '5px', fontSize: '12px', width: '100%' }}
                                  />
                                  <span style={{ fontSize: '11px', color: '#666' }}>LTC</span>

                                  <label style={{ fontSize: '12px' }}>DOGE Max:</label>
                                  <input
                                    type="number"
                                    step="0.01"
                                    value={this.state.dogeMaxLimit}
                                    onChange={(e) => this.handleLimitChange('dogeMaxLimit', e.target.value)}
                                    style={{ padding: '5px', fontSize: '12px', width: '100%' }}
                                  />
                                  <span style={{ fontSize: '11px', color: '#666' }}>DOGE</span>
                                </div>
                              </div>
                            )}

                            {/* Time Maximum Mode */}
                            {this.state.limitMode === 'time_max' && (
                              <div style={{ marginBottom: '12px', padding: '12px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                                <h5 style={{ margin: '0 0 10px 0', fontSize: '13px' }}>Time Limit</h5>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                  <label style={{ fontSize: '12px' }}>Maximum Days:</label>
                                  <input
                                    type="number"
                                    min="1"
                                    value={this.state.timeMaxDays}
                                    onChange={(e) => this.handleLimitChange('timeMaxDays', e.target.value)}
                                    style={{ padding: '5px', fontSize: '12px', width: '100px' }}
                                  />
                                  <span style={{ fontSize: '11px', color: '#666' }}>days</span>
                                </div>

                                {/* Show last close-out times */}
                                <div style={{ marginTop: '10px', fontSize: '11px', color: '#666' }}>
                                  <div>Last BTC close-out: {this.state.lastCloseoutBtc ? new Date(this.state.lastCloseoutBtc).toLocaleDateString() : 'Never'}</div>
                                  <div>Last LTC close-out: {this.state.lastCloseoutLtc ? new Date(this.state.lastCloseoutLtc).toLocaleDateString() : 'Never'}</div>
                                  <div>Last DOGE close-out: {this.state.lastCloseoutDoge ? new Date(this.state.lastCloseoutDoge).toLocaleDateString() : 'Never'}</div>
                                </div>
                              </div>
                            )}

                            <button
                              onClick={() => this.handleSaveLimits(store.store_id)}
                              disabled={this.state.savingLimitsFor === store.store_id}
                              style={{
                                padding: '8px 16px',
                                backgroundColor: this.state.savingLimitsFor === store.store_id ? '#6c757d' : '#2196F3',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: this.state.savingLimitsFor === store.store_id ? 'not-allowed' : 'pointer',
                                fontSize: '13px'
                              }}
                            >
                              {this.state.savingLimitsFor === store.store_id ? 'Saving...' : 'Save Limit Settings'}
                            </button>
                          </div>
                        )}
                      </div>

                      {/* View Employees Button */}
                      <div style={{
                        marginTop: '12px',
                        paddingTop: '12px',
                        borderTop: '1px solid #e1e8ed'
                      }}>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            this.handleViewEmployees(store);
                          }}
                          style={{
                            width: '100%',
                            padding: '10px 16px',
                            backgroundColor: '#17a2b8',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px',
                            transition: 'background-color 0.2s'
                          }}
                          onMouseEnter={(e) => e.target.style.backgroundColor = '#138496'}
                          onMouseLeave={(e) => e.target.style.backgroundColor = '#17a2b8'}
                        >
                          <span style={{ fontSize: '16px' }}>👥</span>
                          View Employees
                          {this.state.employeeCounts[store.store_id] !== undefined && (
                            <span style={{
                              marginLeft: '4px',
                              padding: '2px 8px',
                              borderRadius: '12px',
                              backgroundColor: 'rgba(255, 255, 255, 0.2)',
                              fontSize: '13px',
                              fontWeight: '600'
                            }}>
                              {this.state.employeeCounts[store.store_id]}
                            </span>
                          )}
                        </button>
                      </div>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
                </div>
              );
            })()
          )}

              <div style={{ marginTop: '16px', padding: '12px', background: '#f8f9fa', borderRadius: '6px' }}>
                <p style={{ margin: '0 0 8px 0', fontSize: '13px', color: '#666', fontWeight: '600' }}>
                  Fee Percentage Guidelines:
                </p>
                <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '13px', color: '#666' }}>
                  <li>Default: 2.50% (standard Ðijitto fee)</li>
                  <li>Minimum: 1.00% (high-volume retailers)</li>
                  <li>Maximum: 3.00% (premium service tier)</li>
                  <li>Changes take effect on next payout calculation</li>
                </ul>
              </div>
            </>
          )}
        </div>

        <div className="admin-section">
          {/* Collapsible Section Header */}
          <div
            onClick={() => this.toggleSectionCollapsed('waitlistManagement')}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              cursor: 'pointer',
              userSelect: 'none',
              marginBottom: '20px',
              padding: '12px',
              backgroundColor: '#f8f9fa',
              borderRadius: '8px',
              border: '2px solid #e1e8ed',
              transition: 'all 0.2s'
            }}
          >
            <div style={{ fontSize: '20px', color: '#666', minWidth: '24px' }}>
              {this.state.collapsedSections.has('waitlistManagement') ? '▶' : '▼'}
            </div>
            <h3 style={{ margin: 0, flex: 1 }}>Merchant Waitlist Management</h3>
            <div style={{ fontSize: '14px', color: '#999', fontWeight: 'normal' }}>
              {this.state.storeRequests.length} {this.state.storeRequests.length === 1 ? 'request' : 'requests'}
            </div>
          </div>

          {!this.state.collapsedSections.has('waitlistManagement') && (
            <>
              <p style={{ color: '#666', marginBottom: '20px' }}>
                Review merchants on the waitlist and approve them when you're ready to onboard. Click a request to expand details.
              </p>

              {/* Search Input */}
          <div style={{ marginBottom: '16px' }}>
            <input
              type="text"
              placeholder="🔍 Search by business name, contact, or email..."
              value={this.state.waitlistSearchTerm}
              onChange={this.handleWaitlistSearchChange}
              style={{
                width: '100%',
                padding: '12px 16px',
                border: '2px solid #e1e8ed',
                borderRadius: '8px',
                fontSize: '14px',
                outline: 'none',
                transition: 'border-color 0.2s'
              }}
              onFocus={(e) => e.target.style.borderColor = '#007bff'}
              onBlur={(e) => e.target.style.borderColor = '#e1e8ed'}
            />
          </div>

          {this.state.loadingRequests ? (
            <div style={{ textAlign: 'center', padding: '20px' }}>
              <p style={{ color: '#999' }}>Loading waitlist...</p>
            </div>
          ) : this.state.storeRequests.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '20px', background: '#f8f9fa', borderRadius: '8px' }}>
              <p style={{ color: '#999', margin: 0 }}>Waitlist is empty</p>
            </div>
          ) : (
            (() => {
              const filteredRequests = this.state.storeRequests.filter(request => {
                // Filter by search term
                if (!this.state.waitlistSearchTerm) return true;
                const searchLower = this.state.waitlistSearchTerm.toLowerCase();
                const businessName = (request.business_name || '').toLowerCase();
                const contactName = (request.contact_name || '').toLowerCase();
                const contactEmail = (request.contact_email || '').toLowerCase();
                const desiredStoreName = (request.desired_store_name || '').toLowerCase();
                return businessName.includes(searchLower) ||
                       contactName.includes(searchLower) ||
                       contactEmail.includes(searchLower) ||
                       desiredStoreName.includes(searchLower);
              });

              if (filteredRequests.length === 0) {
                return (
                  <div style={{ textAlign: 'center', padding: '40px 20px', background: '#f8f9fa', borderRadius: '8px' }}>
                    <p style={{ color: '#999', margin: 0, fontSize: '14px' }}>
                      {this.state.waitlistSearchTerm ?
                        `No requests found matching "${this.state.waitlistSearchTerm}"` :
                        'Waitlist is empty'}
                    </p>
                  </div>
                );
              }

              return (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  {filteredRequests.map(request => {
                    const isApproving = this.state.approvingRequest === request.request_id;
                    const isDenying = this.state.denyingRequest === request.request_id;
                    const isProcessing = isApproving || isDenying;
                    const isExpanded = this.state.expandedWaitlistRequests.has(request.request_id);

                    return (
                      <div
                        key={request.request_id}
                        style={{
                          border: '2px solid #e1e8ed',
                          borderRadius: '8px',
                          background: 'white',
                          transition: 'all 0.2s'
                        }}
                      >
                        {/* Collapsible Header */}
                        <div
                          onClick={() => this.toggleWaitlistExpanded(request.request_id)}
                          style={{
                            padding: '16px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            userSelect: 'none'
                          }}
                        >
                          {/* Expand/Collapse Icon */}
                          <div style={{ fontSize: '18px', color: '#666', minWidth: '20px' }}>
                            {isExpanded ? '▼' : '▶'}
                          </div>

                          {/* Status Badge */}
                          <div style={{
                            display: 'inline-flex',
                            padding: '4px 12px',
                            borderRadius: '12px',
                            fontSize: '12px',
                            fontWeight: '600',
                            backgroundColor: '#e3f2fd',
                            color: '#1565c0',
                            border: '1px solid #64b5f6',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                          }}>
                            ON WAITLIST
                          </div>

                          {/* Business Name and Contact */}
                          <div style={{ flex: 1 }}>
                            <div style={{ fontSize: '15px', fontWeight: '600', color: '#333' }}>
                              {request.business_name}
                            </div>
                            <div style={{ fontSize: '13px', color: '#666', marginTop: '2px' }}>
                              {request.contact_name} • {request.contact_email}
                            </div>
                          </div>

                          {/* Submitted Date */}
                          <div style={{
                            padding: '6px 12px',
                            borderRadius: '6px',
                            fontSize: '12px',
                            fontWeight: '500',
                            backgroundColor: '#f0f0f0',
                            color: '#666'
                          }}>
                            {new Date(request.created_at).toLocaleDateString()}
                          </div>
                        </div>

                        {/* Expanded Content */}
                        {isExpanded && (
                          <div style={{ padding: '0 16px 16px 16px', borderTop: '1px solid #e1e8ed' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '12px' }}>

                      {/* Business Info */}
                      <div style={{ display: 'flex', justifyContent: 'space-between', gap: '16px' }}>
                        <div style={{ flex: 1 }}>
                          <div style={{ marginBottom: '12px' }}>
                            <div style={{ fontSize: '16px', fontWeight: '600', color: '#333', marginBottom: '4px' }}>
                              {request.business_name}
                            </div>
                            <div style={{ fontSize: '13px', color: '#666' }}>
                              Desired Store Name: {request.desired_store_name}
                            </div>
                          </div>

                          <div style={{ fontSize: '13px', color: '#666', marginBottom: '8px' }}>
                            <strong>Contact:</strong> {request.contact_name} ({request.contact_email})
                          </div>

                          {request.contact_phone && (
                            <div style={{ fontSize: '13px', color: '#666', marginBottom: '8px' }}>
                              <strong>Phone:</strong> {request.contact_phone}
                            </div>
                          )}

                          {request.physical_location && (
                            <div style={{ fontSize: '13px', color: '#666', marginBottom: '8px' }}>
                              <strong>Location:</strong> {request.physical_location}
                            </div>
                          )}

                          {request.website && (
                            <div style={{ fontSize: '13px', color: '#666', marginBottom: '8px' }}>
                              <strong>Website:</strong>{' '}
                              <a href={request.website} target="_blank" rel="noopener noreferrer">
                                {request.website}
                              </a>
                            </div>
                          )}

                          {request.business_description && (
                            <div style={{ fontSize: '13px', color: '#666', marginTop: '12px', padding: '12px', background: '#f8f9fa', borderRadius: '6px' }}>
                              <strong>Description:</strong><br />
                              {request.business_description}
                            </div>
                          )}

                          <div style={{ fontSize: '12px', color: '#999', marginTop: '12px' }}>
                            Request ID: {request.request_id}<br />
                            Submitted: {new Date(request.created_at).toLocaleDateString()} {new Date(request.created_at).toLocaleTimeString()}
                          </div>
                        </div>
                      </div>

                      {/* Action Buttons */}
                      <div style={{ display: 'flex', gap: '12px', marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #e1e8ed' }}>
                        <button
                          onClick={() => this.handleApproveRequest(request.request_id, request.business_name)}
                          disabled={isApproving}
                          style={{
                            flex: 1,
                            padding: '12px 24px',
                            backgroundColor: isApproving ? '#6c757d' : '#28a745',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: isApproving ? 'not-allowed' : 'pointer',
                            fontSize: '15px',
                            fontWeight: '500',
                            transition: 'background-color 0.2s'
                          }}
                        >
                          {isApproving ? 'Approving & Creating Store...' : '✓ Approve & Create Store'}
                        </button>
                      </div>
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              );
            })()
          )}

              <div style={{ marginTop: '16px', padding: '12px', background: '#f8f9fa', borderRadius: '6px' }}>
                <p style={{ margin: '0 0 8px 0', fontSize: '13px', color: '#666', fontWeight: '600' }}>
                  Waitlist Workflow:
                </p>
                <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '13px', color: '#666' }}>
                  <li>Merchants join the waitlist through the public request form</li>
                  <li>Approve merchants when you're ready to onboard them</li>
                  <li>Approval creates a store account with sequential ID and random password</li>
                  <li>Credentials displayed in alert - copy and send to merchant via email</li>
                  <li>Merchants not yet approved simply remain on the waitlist</li>
                  <li>All approvals require owner password confirmation</li>
                </ul>
              </div>
            </>
          )}
        </div>

        {/* ======================================== */}
        {/* Sales Rep Management Section */}
        {/* ======================================== */}
        <div className="admin-section sales-rep-section">
          <div
            onClick={() => this.toggleSectionCollapsed('salesRepManagement')}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              cursor: 'pointer',
              userSelect: 'none',
              marginBottom: '20px',
              padding: '12px',
              backgroundColor: '#f8f9fa',
              borderRadius: '8px',
              border: '2px solid #e1e8ed',
              transition: 'all 0.2s'
            }}
          >
            <div style={{ fontSize: '20px', color: '#666', minWidth: '24px' }}>
              {this.state.collapsedSections.has('salesRepManagement') ? '▶' : '▼'}
            </div>
            <h3 style={{ margin: 0, flex: 1 }}>💼 Sales Rep Management</h3>
            <div style={{ fontSize: '14px', color: '#999', fontWeight: 'normal' }}>
              {this.state.salesReps.length} {this.state.salesReps.length === 1 ? 'rep' : 'reps'}
            </div>
          </div>

          {!this.state.collapsedSections.has('salesRepManagement') && (
            <>
              <p style={{ color: '#666', marginBottom: '20px' }}>
                Manage sales representatives who earn commissions on store transactions. Each rep can have crypto addresses for BTC, LTC, and DOGE.
              </p>

              {/* Create New Button */}
              <div style={{ marginBottom: '16px' }}>
                <button
                  onClick={this.handleCreateSalesRep}
                  disabled={this.state.editingSalesRep !== null}
                  style={{
                    padding: '10px 20px',
                    backgroundColor: this.state.editingSalesRep ? '#ccc' : '#28a745',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: this.state.editingSalesRep ? 'not-allowed' : 'pointer',
                    fontSize: '14px',
                    fontWeight: '500'
                  }}
                >
                  + Create New Sales Rep
                </button>
              </div>

              {/* Create/Edit Form */}
              {this.state.editingSalesRep && (
                <div style={{
                  marginBottom: '20px',
                  padding: '20px',
                  background: '#fff',
                  border: '2px solid #007bff',
                  borderRadius: '8px'
                }}>
                  <h4 style={{ marginTop: 0 }}>
                    {this.state.editingSalesRep === 'new' ? 'Create New Sales Rep' : 'Edit Sales Rep'}
                  </h4>

                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
                    <div>
                      <label style={{ fontSize: '12px', color: '#666', display: 'block', marginBottom: '4px' }}>
                        Name *
                      </label>
                      <input
                        type="text"
                        value={this.state.salesRepForm.name}
                        onChange={(e) => this.handleSalesRepFormChange('name', e.target.value)}
                        placeholder="John Smith"
                        style={{
                          width: '100%',
                          padding: '8px 12px',
                          border: '2px solid #e1e8ed',
                          borderRadius: '6px',
                          fontSize: '14px'
                        }}
                      />
                    </div>
                    <div>
                      <label style={{ fontSize: '12px', color: '#666', display: 'block', marginBottom: '4px' }}>
                        Email *
                      </label>
                      <input
                        type="email"
                        value={this.state.salesRepForm.email}
                        onChange={(e) => this.handleSalesRepFormChange('email', e.target.value)}
                        placeholder="john@example.com"
                        style={{
                          width: '100%',
                          padding: '8px 12px',
                          border: '2px solid #e1e8ed',
                          borderRadius: '6px',
                          fontSize: '14px'
                        }}
                      />
                    </div>
                  </div>

                  <div style={{ marginBottom: '12px' }}>
                    <label style={{ fontSize: '12px', color: '#666', display: 'block', marginBottom: '4px' }}>
                      BTC Address
                    </label>
                    <input
                      type="text"
                      value={this.state.salesRepForm.btc_address}
                      onChange={(e) => this.handleSalesRepFormChange('btc_address', e.target.value)}
                      placeholder="bc1q..."
                      style={{
                        width: '100%',
                        padding: '8px 12px',
                        border: '2px solid #e1e8ed',
                        borderRadius: '6px',
                        fontSize: '14px',
                        fontFamily: 'monospace'
                      }}
                    />
                  </div>

                  <div style={{ marginBottom: '12px' }}>
                    <label style={{ fontSize: '12px', color: '#666', display: 'block', marginBottom: '4px' }}>
                      LTC Address
                    </label>
                    <input
                      type="text"
                      value={this.state.salesRepForm.ltc_address}
                      onChange={(e) => this.handleSalesRepFormChange('ltc_address', e.target.value)}
                      placeholder="ltc1q..."
                      style={{
                        width: '100%',
                        padding: '8px 12px',
                        border: '2px solid #e1e8ed',
                        borderRadius: '6px',
                        fontSize: '14px',
                        fontFamily: 'monospace'
                      }}
                    />
                  </div>

                  <div style={{ marginBottom: '12px' }}>
                    <label style={{ fontSize: '12px', color: '#666', display: 'block', marginBottom: '4px' }}>
                      DOGE Address
                    </label>
                    <input
                      type="text"
                      value={this.state.salesRepForm.doge_address}
                      onChange={(e) => this.handleSalesRepFormChange('doge_address', e.target.value)}
                      placeholder="D..."
                      style={{
                        width: '100%',
                        padding: '8px 12px',
                        border: '2px solid #e1e8ed',
                        borderRadius: '6px',
                        fontSize: '14px',
                        fontFamily: 'monospace'
                      }}
                    />
                  </div>

                  <div style={{ marginBottom: '16px' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                      <input
                        type="checkbox"
                        checked={this.state.salesRepForm.active}
                        onChange={(e) => this.handleSalesRepFormChange('active', e.target.checked)}
                      />
                      <span style={{ fontSize: '14px', color: '#666' }}>Active</span>
                    </label>
                  </div>

                  <div style={{ display: 'flex', gap: '12px' }}>
                    <button
                      onClick={this.handleSaveSalesRep}
                      disabled={this.state.savingSalesRep}
                      style={{
                        padding: '10px 20px',
                        backgroundColor: this.state.savingSalesRep ? '#6c757d' : '#28a745',
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: this.state.savingSalesRep ? 'not-allowed' : 'pointer',
                        fontSize: '14px',
                        fontWeight: '500'
                      }}
                    >
                      {this.state.savingSalesRep ? 'Saving...' : 'Save'}
                    </button>
                    <button
                      onClick={this.handleCancelEdit}
                      disabled={this.state.savingSalesRep}
                      style={{
                        padding: '10px 20px',
                        backgroundColor: '#6c757d',
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: this.state.savingSalesRep ? 'not-allowed' : 'pointer',
                        fontSize: '14px',
                        fontWeight: '500'
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              )}

              {/* Search */}
              <div style={{ marginBottom: '16px' }}>
                <input
                  type="text"
                  placeholder="🔍 Search by name or email..."
                  value={this.state.salesRepSearchTerm}
                  onChange={this.handleSalesRepSearchChange}
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '2px solid #e1e8ed',
                    borderRadius: '8px',
                    fontSize: '14px',
                    outline: 'none'
                  }}
                />
              </div>

              {/* Sales Reps List */}
              {this.state.loadingSalesReps ? (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                  <p style={{ color: '#999' }}>Loading sales reps...</p>
                </div>
              ) : this.state.salesReps.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '20px', background: '#f8f9fa', borderRadius: '8px' }}>
                  <p style={{ color: '#999', margin: 0 }}>No sales reps found</p>
                </div>
              ) : (
                (() => {
                  const filteredReps = this.state.salesReps.filter(rep => {
                    if (!this.state.salesRepSearchTerm) return true;
                    const searchLower = this.state.salesRepSearchTerm.toLowerCase();
                    return rep.name.toLowerCase().includes(searchLower) ||
                           rep.email.toLowerCase().includes(searchLower);
                  });

                  if (filteredReps.length === 0) {
                    return (
                      <div style={{ textAlign: 'center', padding: '20px', background: '#f8f9fa', borderRadius: '8px' }}>
                        <p style={{ color: '#999', margin: 0 }}>No sales reps found matching "{this.state.salesRepSearchTerm}"</p>
                      </div>
                    );
                  }

                  return (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                      {filteredReps.map(rep => {
                        const isExpanded = this.state.expandedSalesReps.has(rep.id);
                        const isDeleting = this.state.deletingSalesRep === rep.id;

                        return (
                          <div
                            key={rep.id}
                            style={{
                              border: '2px solid #e1e8ed',
                              borderRadius: '8px',
                              overflow: 'hidden',
                              backgroundColor: rep.active ? '#fff' : '#f8f9fa'
                            }}
                          >
                            <div
                              onClick={() => this.toggleSalesRepExpanded(rep.id)}
                              style={{
                                padding: '16px',
                                cursor: 'pointer',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                gap: '12px'
                              }}
                            >
                              <div style={{ flex: 1 }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '4px' }}>
                                  <strong style={{ fontSize: '16px' }}>{rep.name}</strong>
                                  {!rep.active && (
                                    <span style={{
                                      padding: '2px 8px',
                                      borderRadius: '4px',
                                      fontSize: '11px',
                                      fontWeight: '600',
                                      backgroundColor: '#f8d7da',
                                      color: '#721c24'
                                    }}>
                                      Inactive
                                    </span>
                                  )}
                                </div>
                                <div style={{ fontSize: '13px', color: '#666' }}>{rep.email}</div>
                              </div>
                              <div style={{ fontSize: '20px', color: '#666' }}>
                                {isExpanded ? '▼' : '▶'}
                              </div>
                            </div>

                            {isExpanded && (
                              <div style={{ padding: '0 16px 16px 16px', borderTop: '1px solid #e1e8ed' }}>
                                <div style={{ marginTop: '12px', display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '8px', fontSize: '13px' }}>
                                  <strong>BTC:</strong>
                                  <span style={{ fontFamily: 'monospace', wordBreak: 'break-all', color: rep.btc_address ? '#333' : '#999' }}>
                                    {rep.btc_address || 'Not provided'}
                                  </span>

                                  <strong>LTC:</strong>
                                  <span style={{ fontFamily: 'monospace', wordBreak: 'break-all', color: rep.ltc_address ? '#333' : '#999' }}>
                                    {rep.ltc_address || 'Not provided'}
                                  </span>

                                  <strong>DOGE:</strong>
                                  <span style={{ fontFamily: 'monospace', wordBreak: 'break-all', color: rep.doge_address ? '#333' : '#999' }}>
                                    {rep.doge_address || 'Not provided'}
                                  </span>
                                </div>

                                <div style={{ marginTop: '16px', display: 'flex', gap: '12px' }}>
                                  <button
                                    onClick={() => this.handleEditSalesRep(rep)}
                                    disabled={this.state.editingSalesRep !== null || isDeleting}
                                    style={{
                                      padding: '8px 16px',
                                      backgroundColor: (this.state.editingSalesRep || isDeleting) ? '#ccc' : '#007bff',
                                      color: 'white',
                                      border: 'none',
                                      borderRadius: '6px',
                                      cursor: (this.state.editingSalesRep || isDeleting) ? 'not-allowed' : 'pointer',
                                      fontSize: '13px',
                                      fontWeight: '500'
                                    }}
                                  >
                                    Edit
                                  </button>
                                  <button
                                    onClick={() => this.handleDeleteSalesRep(rep.id)}
                                    disabled={this.state.editingSalesRep !== null || isDeleting}
                                    style={{
                                      padding: '8px 16px',
                                      backgroundColor: isDeleting ? '#6c757d' : '#dc3545',
                                      color: 'white',
                                      border: 'none',
                                      borderRadius: '6px',
                                      cursor: (this.state.editingSalesRep || isDeleting) ? 'not-allowed' : 'pointer',
                                      fontSize: '13px',
                                      fontWeight: '500'
                                    }}
                                  >
                                    {isDeleting ? 'Deleting...' : 'Delete'}
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  );
                })()
              )}
            </>
          )}
        </div>

        {/* ======================================== */}
        {/* Sales Rep Dashboard Section */}
        {/* ======================================== */}
        <div className="admin-section">
          <div
            onClick={() => this.toggleSectionCollapsed('salesRepDashboard')}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              cursor: 'pointer',
              userSelect: 'none',
              marginBottom: '20px',
              padding: '12px',
              backgroundColor: '#f8f9fa',
              borderRadius: '8px',
              border: '2px solid #e1e8ed',
              transition: 'all 0.2s'
            }}
          >
            <div style={{ fontSize: '20px', color: '#666', minWidth: '24px' }}>
              {this.state.collapsedSections.has('salesRepDashboard') ? '▶' : '▼'}
            </div>
            <h3 style={{ margin: 0, flex: 1 }}>📊 Sales Rep Dashboard</h3>
          </div>

          {!this.state.collapsedSections.has('salesRepDashboard') && (
            <>
              <div style={{ marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                <label style={{ fontSize: '14px', color: '#666' }}>Time Range:</label>
                <select
                  value={this.state.dashboardTimeRange}
                  onChange={this.handleDashboardTimeRangeChange}
                  style={{
                    padding: '8px 12px',
                    border: '2px solid #e1e8ed',
                    borderRadius: '6px',
                    fontSize: '14px'
                  }}
                >
                  <option value="7">Last 7 days</option>
                  <option value="30">Last 30 days</option>
                  <option value="90">Last 90 days</option>
                  <option value="365">Last year</option>
                </select>
              </div>

              {this.state.loadingDashboard ? (
                <div style={{ textAlign: 'center', padding: '40px' }}>
                  <p style={{ color: '#999' }}>Loading dashboard...</p>
                </div>
              ) : !this.state.dashboardData ? (
                <div style={{ textAlign: 'center', padding: '40px', background: '#f8f9fa', borderRadius: '8px' }}>
                  <p style={{ color: '#999', margin: 0 }}>No dashboard data available</p>
                </div>
              ) : (
                <>
                  {/* Overview Cards */}
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', marginBottom: '24px' }}>
                    <div style={{ padding: '16px', background: '#fff', border: '2px solid #e1e8ed', borderRadius: '8px' }}>
                      <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>Total Commissions Paid</div>
                      <div style={{ fontSize: '24px', fontWeight: '600', color: '#28a745' }}>
                        {this.state.dashboardData.overview.totalCommissionsPaid.toFixed(8)}
                      </div>
                      <div style={{ fontSize: '11px', color: '#999' }}>
                        {this.state.dashboardData.overview.payoutCount} payouts
                      </div>
                    </div>

                    <div style={{ padding: '16px', background: '#fff', border: '2px solid #e1e8ed', borderRadius: '8px' }}>
                      <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>Active Sales Reps</div>
                      <div style={{ fontSize: '24px', fontWeight: '600', color: '#007bff' }}>
                        {this.state.dashboardData.overview.activeSalesReps}
                      </div>
                    </div>

                    <div style={{ padding: '16px', background: '#fff', border: '2px solid #e1e8ed', borderRadius: '8px' }}>
                      <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>Stores with Reps</div>
                      <div style={{ fontSize: '24px', fontWeight: '600', color: '#6c757d' }}>
                        {this.state.dashboardData.overview.storesWithReps} / {this.state.dashboardData.overview.totalStores}
                      </div>
                    </div>

                    <div style={{ padding: '16px', background: '#fff', border: '2px solid #e1e8ed', borderRadius: '8px' }}>
                      <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>Avg Commission Rate</div>
                      <div style={{ fontSize: '24px', fontWeight: '600', color: '#ffc107' }}>
                        {this.state.dashboardData.overview.avgCommissionRate}%
                      </div>
                    </div>
                  </div>

                  {/* Top Performers */}
                  {this.state.dashboardData.topPerformers && this.state.dashboardData.topPerformers.length > 0 && (
                    <div style={{ marginBottom: '24px' }}>
                      <h4 style={{ marginBottom: '12px' }}>Top Performers</h4>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        {this.state.dashboardData.topPerformers.map((rep, index) => (
                          <div
                            key={rep.id}
                            style={{
                              padding: '12px',
                              background: '#fff',
                              border: '2px solid #e1e8ed',
                              borderRadius: '6px',
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center'
                            }}
                          >
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                              <div style={{
                                width: '32px',
                                height: '32px',
                                borderRadius: '50%',
                                background: index === 0 ? '#ffd700' : (index === 1 ? '#c0c0c0' : (index === 2 ? '#cd7f32' : '#e1e8ed')),
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontWeight: '600',
                                fontSize: '14px'
                              }}>
                                #{index + 1}
                              </div>
                              <div>
                                <div style={{ fontWeight: '600', fontSize: '14px' }}>{rep.name}</div>
                                <div style={{ fontSize: '12px', color: '#666' }}>
                                  {rep.store_count || 0} {rep.store_count === 1 ? 'store' : 'stores'} • {rep.payout_count || 0} payouts
                                </div>
                              </div>
                            </div>
                            <div style={{ textAlign: 'right' }}>
                              <div style={{ fontSize: '16px', fontWeight: '600', color: '#28a745' }}>
                                {parseFloat(rep.total_earned || 0).toFixed(8)}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Earnings by Crypto */}
                  {this.state.dashboardData.earningsByCrypto && this.state.dashboardData.earningsByCrypto.length > 0 && (
                    <div>
                      <h4 style={{ marginBottom: '12px' }}>Commissions by Cryptocurrency</h4>
                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '12px' }}>
                        {this.state.dashboardData.earningsByCrypto.map(crypto => (
                          <div
                            key={crypto.crypto}
                            style={{
                              padding: '12px',
                              background: '#fff',
                              border: '2px solid #e1e8ed',
                              borderRadius: '6px',
                              textAlign: 'center'
                            }}
                          >
                            <div style={{ fontSize: '18px', fontWeight: '600', marginBottom: '4px' }}>
                              {crypto.crypto.toUpperCase()}
                            </div>
                            <div style={{ fontSize: '14px', color: '#28a745', fontWeight: '600' }}>
                              {parseFloat(crypto.total_amount || 0).toFixed(8)}
                            </div>
                            <div style={{ fontSize: '11px', color: '#999' }}>
                              {crypto.payout_count || 0} payouts
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </>
              )}
            </>
          )}
        </div>

        <div className="admin-section">
          {/* Collapsible Section Header */}
          <div
            onClick={() => this.toggleSectionCollapsed('walletDetection')}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              cursor: 'pointer',
              userSelect: 'none',
              marginBottom: '20px',
              padding: '12px',
              backgroundColor: '#f8f9fa',
              borderRadius: '8px',
              border: '2px solid #e1e8ed',
              transition: 'all 0.2s'
            }}
          >
            <div style={{ fontSize: '20px', color: '#666', minWidth: '24px' }}>
              {this.state.collapsedSections.has('walletDetection') ? '▶' : '▼'}
            </div>
            <h3 style={{ margin: 0, flex: 1 }}>🔍 Unauthorized Wallet Detection</h3>
          </div>

          {!this.state.collapsedSections.has('walletDetection') && (
            <>
              <p style={{color: '#666', marginBottom: '20px'}}>
                Monitor retailers for unauthorized wallet activity (external spending of payment addresses).
                This detects if a retailer is using their seed phrase in a different wallet to bypass fees.
              </p>

          <div style={{marginBottom: '20px'}}>
            <label style={{display: 'block', marginBottom: '8px', fontWeight: 'bold'}}>
              Store ID:
            </label>
            <input
              type="text"
              placeholder="Enter store ID (e.g., 20001937)"
              value={this.state.monitorStoreId || ''}
              onChange={(e) => this.setState({monitorStoreId: e.target.value})}
              style={{
                padding: '8px 12px',
                fontSize: '16px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                width: '300px',
                marginRight: '15px'
              }}
            />
            <select
              value={this.state.monitorCrypto || 'doge'}
              onChange={(e) => this.setState({monitorCrypto: e.target.value})}
              style={{
                padding: '8px 12px',
                fontSize: '16px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                width: '120px'
              }}>
              <option value="doge">DOGE</option>
              <option value="btc">BTC</option>
              <option value="ltc">LTC</option>
            </select>
          </div>

          <button
            onClick={async () => {
              const storeId = this.state.monitorStoreId;
              const crypto = this.state.monitorCrypto || 'doge';

              if (!storeId) {
                window.alert('Please enter a Store ID');
                return;
              }

              const confirmed = window.confirm(
                `Check store ${storeId} for unauthorized ${crypto.toUpperCase()} wallet activity?\n\n` +
                `This will scan all payment addresses for transactions not created by ÐijittoExpress.`
              );

              if (!confirmed) return;

              try {
                const apiBase = process.env.REACT_APP_API_BASE_URL || getApiBaseUrl();
                const response = await fetch(`${apiBase}/stores/${storeId}/reconcile/${crypto}`, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ check_unauthorized: true })
                });

                if (!response.ok) {
                  throw new Error(`HTTP ${response.status}: ${response.statusText}`);
                }

                const data = await response.json();

                if (data.unauthorized_activity) {
                  const txList = data.unauthorized_transactions.map(tx =>
                    `  • ${tx.txid.substring(0, 16)}... (${tx.amount_crypto} ${crypto.toUpperCase()}) from ${tx.from_address.substring(0, 12)}...`
                  ).join('\n');

                  // Check if backend already auto-suspended the account
                  if (data.account_suspended) {
                    window.alert(
                      `🚨 UNAUTHORIZED ACTIVITY DETECTED!\n\n` +
                      `Store: ${storeId}\n` +
                      `Found ${data.unauthorized_count} unauthorized transaction(s):\n\n${txList}\n\n` +
                      `Total unauthorized: ${data.total_unauthorized_amount} ${crypto.toUpperCase()}\n\n` +
                      `✅ ACCOUNT AUTOMATICALLY SUSPENDED\n\n` +
                      `The account has been automatically suspended and can no longer accept payments.\n\n` +
                      `The store list will now refresh to show the updated status.`
                    );

                    // Refresh store list to show updated suspension status
                    await this.fetchStores();
                  } else {
                    // Backend didn't auto-suspend (shouldn't happen with new code, but keep as fallback)
                    const suspendConfirm = window.confirm(
                      `🚨 UNAUTHORIZED ACTIVITY DETECTED!\n\n` +
                      `Store: ${storeId}\n` +
                      `Found ${data.unauthorized_count} unauthorized transaction(s):\n\n${txList}\n\n` +
                      `Total unauthorized: ${data.total_unauthorized_amount} ${crypto.toUpperCase()}\n\n` +
                      `Recommendation: ${data.recommendation}\n\n` +
                      `Auto-suspension did not occur. Do you want to SUSPEND this account manually?`
                    );

                    if (suspendConfirm) {
                      // Manual suspension (fallback only)
                      const suspendResponse = await fetch(`${apiBase}/stores/${storeId}/suspend`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                          reason: 'Unauthorized wallet activity detected',
                          detected_txid: data.unauthorized_transactions[0].txid,
                          crypto: crypto.toUpperCase(),
                          amount_unauthorized: data.total_unauthorized_amount,
                          performed_by: 'admin'
                        })
                      });

                      if (suspendResponse.ok) {
                        window.alert(`✅ Account Suspended\n\nStore ${storeId} has been suspended and can no longer accept payments.`);
                        // Refresh store list to show updated suspension status
                        await this.fetchStores();
                      } else {
                        window.alert(`⚠️ Failed to suspend account. Please check the backend logs.`);
                      }
                    }
                  }
                } else {
                  window.alert(
                    `✅ No Unauthorized Activity Detected\n\n` +
                    `Store: ${storeId}\n` +
                    `All ${crypto.toUpperCase()} transactions are authorized.\n` +
                    `Wallet is secure.`
                  );
                }
              } catch (error) {
                console.error('Error checking unauthorized activity:', error);
                window.alert(`❌ Error checking for unauthorized activity:\n\n${error.message}`);
              }
            }}
            style={{
              padding: '12px 24px',
              fontSize: '16px',
              backgroundColor: '#dc3545',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              marginRight: '10px'
            }}>
            🔍 Check for Unauthorized Activity
          </button>

          <button
            onClick={async () => {
              const storeId = this.state.monitorStoreId;

              if (!storeId) {
                window.alert('Please enter a Store ID');
                return;
              }

              try {
                const apiBase = process.env.REACT_APP_API_BASE_URL || getApiBaseUrl();
                const response = await fetch(`${apiBase}/stores/${storeId}/suspension-status`);

                if (!response.ok) {
                  throw new Error(`HTTP ${response.status}: ${response.statusText}`);
                }

                const data = await response.json();

                if (data.is_suspended) {
                  window.alert(
                    `🚫 ACCOUNT SUSPENDED\n\n` +
                    `Store: ${data.store_name} (${storeId})\n` +
                    `Reason: ${data.suspension_reason}\n` +
                    `Suspended at: ${new Date(data.suspended_at).toLocaleString()}\n` +
                    `Suspended by: ${data.suspended_by}\n\n` +
                    `Event history: ${data.history.length} events`
                  );
                } else {
                  window.alert(
                    `✅ Account Active\n\n` +
                    `Store: ${data.store_name} (${storeId})\n` +
                    `Status: Not suspended\n` +
                    `Event history: ${data.history.length} events`
                  );
                }
              } catch (error) {
                console.error('Error checking suspension status:', error);
                window.alert(`❌ Error checking suspension status:\n\n${error.message}`);
              }
            }}
            style={{
              padding: '12px 24px',
              fontSize: '16px',
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer'
            }}>
            Check Suspension Status
          </button>

          <p style={{fontSize: '12px', color: '#666', marginTop: '15px'}}>
            Checks if payments were spent using an external wallet. If detected, can auto-suspend the account.
          </p>
            </>
          )}
        </div>

        <div className="admin-section">
          <h3>Security</h3>
          <p style={{ color: '#666' }}>
            These settings are critical to Ðijitto revenue. Only the system owner should have access.
            Password protection prevents unauthorized changes.
          </p>
          <ul style={{ listStyle: 'none', padding: 0, marginTop: '15px' }}>
            <li style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
              <strong>Owner password:</strong> Stored in browser localStorage as <code style={{ background: '#f5f5f5', padding: '2px 6px', borderRadius: '3px' }}>owner-password</code>
            </li>
            <li style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
              <strong>Default password:</strong> <code style={{ background: '#f5f5f5', padding: '2px 6px', borderRadius: '3px' }}>owner123</code>
            </li>
            <li style={{ padding: '8px 0' }}>
              <strong>Session auth:</strong> Stored as <code style={{ background: '#f5f5f5', padding: '2px 6px', borderRadius: '3px' }}>system-authenticated</code>
            </li>
          </ul>
        </div>

        <style jsx>{`
          .admin-container {
            max-width: 900px;
            margin: 0 auto;
            padding: 20px;
          }
          .admin-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 30px;
            padding-bottom: 20px;
            border-bottom: 2px solid #eee;
          }
          .admin-header h1 {
            margin: 0;
            font-size: 32px;
            color: #333;
          }
          .home-button {
            padding: 10px 24px;
            background-color: #007bff;
            color: white;
            border: none;
            border-radius: 6px;
            cursor: pointer;
            font-size: 16px;
            font-weight: 500;
            transition: background-color 0.2s;
          }
          .home-button:hover {
            background-color: #0056b3;
          }
          .admin-section {
            background: white;
            border: 1px solid #e1e8ed;
            border-radius: 12px;
            padding: 24px;
            margin-bottom: 20px;
            box-shadow: 0 2px 4px rgba(0,0,0,0.05);
          }
          .admin-section h3 {
            margin: 0 0 16px 0;
            font-size: 20px;
            color: #333;
          }
          .wallet-address-section {
            display: flex;
            flex-direction: column;
            gap: 16px;
          }
          .crypto-address-card {
            border: 2px solid;
            border-radius: 12px;
            padding: 16px;
            background: white;
            transition: all 0.3s ease;
          }
          .crypto-address-card:hover {
            box-shadow: 0 4px 12px rgba(0,0,0,0.1);
            transform: translateY(-2px);
          }
          .crypto-address-doge {
            border-color: #C2A633;
          }
          .crypto-address-btc {
            border-color: #F7931A;
          }
          .crypto-address-ltc {
            border-color: #345D9D;
          }
          .crypto-address-header {
            display: flex;
            align-items: center;
            gap: 12px;
            margin-bottom: 12px;
          }
          .crypto-icon-badge {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-size: 20px;
            font-weight: bold;
            flex-shrink: 0;
          }
          .crypto-icon-doge {
            background-color: #C2A633;
          }
          .crypto-icon-btc {
            background-color: #F7931A;
          }
          .crypto-icon-ltc {
            background-color: #345D9D;
          }
          .crypto-address-label {
            font-weight: 600;
            font-size: 16px;
            color: #333;
          }
          .crypto-address-sublabel {
            font-size: 13px;
            color: #666;
          }
          .crypto-address-input {
            width: 100%;
            padding: 12px 14px;
            border: 2px solid #e1e8ed;
            border-radius: 8px;
            font-family: 'Monaco', 'Menlo', 'Consolas', monospace;
            font-size: 14px;
            transition: border-color 0.2s;
            box-sizing: border-box;
          }
          .crypto-address-input:focus {
            outline: none;
            border-color: #007bff;
          }
          .btn-primary {
            padding: 12px 24px;
            background-color: #007bff;
            color: white;
            border: none;
            border-radius: 8px;
            cursor: pointer;
            font-size: 15px;
            font-weight: 500;
            transition: background-color 0.2s;
          }
          .btn-primary:hover {
            background-color: #0056b3;
          }
          .btn-secondary {
            padding: 12px 24px;
            background-color: #6c757d;
            color: white;
            border: none;
            border-radius: 8px;
            cursor: pointer;
            font-size: 15px;
            font-weight: 500;
            transition: background-color 0.2s;
          }
          .btn-secondary:hover {
            background-color: #5a6268;
          }
        `}</style>

        {/* Employee Modal */}
        {this.state.showEmployeesModal && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 2000,
              padding: '20px'
            }}
            onClick={this.handleCloseEmployeesModal}
          >
            <div
              style={{
                backgroundColor: 'white',
                borderRadius: '12px',
                maxWidth: '900px',
                width: '100%',
                maxHeight: '80vh',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)'
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {/* Modal Header */}
              <div style={{
                padding: '20px 24px',
                borderBottom: '2px solid #e1e8ed',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}>
                <div>
                  <h3 style={{ margin: 0, fontSize: '20px', fontWeight: '600', color: '#333' }}>
                    👥 Employees
                  </h3>
                  {this.state.selectedStoreForEmployees && (
                    <div style={{ fontSize: '14px', color: '#666', marginTop: '4px' }}>
                      {this.state.selectedStoreForEmployees.store_name || 'Unnamed Store'} (ID: {this.state.selectedStoreForEmployees.store_id})
                    </div>
                  )}
                </div>
                <button
                  onClick={this.handleCloseEmployeesModal}
                  style={{
                    background: 'none',
                    border: 'none',
                    fontSize: '24px',
                    cursor: 'pointer',
                    color: '#999',
                    padding: '0',
                    width: '32px',
                    height: '32px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '4px',
                    transition: 'all 0.2s'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#f0f0f0';
                    e.target.style.color = '#333';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = '#999';
                  }}
                >
                  ×
                </button>
              </div>

              {/* Modal Body */}
              <div style={{
                flex: 1,
                overflowY: 'auto',
                padding: '24px'
              }}>
                {this.state.loadingEmployees ? (
                  <div style={{ textAlign: 'center', padding: '60px 20px' }}>
                    <div style={{
                      border: '4px solid #f3f3f3',
                      borderTop: '4px solid #17a2b8',
                      borderRadius: '50%',
                      width: '50px',
                      height: '50px',
                      animation: 'spin 1s linear infinite',
                      margin: '0 auto'
                    }}></div>
                    <p style={{ marginTop: '20px', color: '#666' }}>Loading employees...</p>
                  </div>
                ) : this.state.employeesForSelectedStore.length === 0 ? (
                  <div style={{
                    textAlign: 'center',
                    padding: '60px 20px',
                    background: '#f8f9fa',
                    borderRadius: '8px',
                    border: '2px dashed #dee2e6'
                  }}>
                    <div style={{ fontSize: '48px', marginBottom: '16px', opacity: 0.3 }}>👥</div>
                    <p style={{ color: '#666', fontSize: '16px', margin: 0 }}>
                      No employees found for this store.
                    </p>
                    <p style={{ color: '#999', fontSize: '14px', marginTop: '8px', margin: 0 }}>
                      Store managers can add employees from the /employees page.
                    </p>
                  </div>
                ) : (
                  <div>
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginBottom: '16px',
                      padding: '12px',
                      backgroundColor: '#f8f9fa',
                      borderRadius: '8px'
                    }}>
                      <div style={{ fontWeight: '600', color: '#333' }}>
                        Total: {this.state.employeesForSelectedStore.length} {this.state.employeesForSelectedStore.length === 1 ? 'employee' : 'employees'}
                      </div>
                      <div style={{ fontSize: '13px', color: '#666' }}>
                        Active employees only
                      </div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                      {this.state.employeesForSelectedStore.map((employee, index) => (
                        <div
                          key={employee.id}
                          style={{
                            border: '2px solid #e1e8ed',
                            borderRadius: '8px',
                            padding: '16px',
                            backgroundColor: 'white',
                            transition: 'all 0.2s'
                          }}
                        >
                          <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            marginBottom: '12px'
                          }}>
                            <div style={{ flex: 1 }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                                <span style={{ fontSize: '16px', fontWeight: '600', color: '#333' }}>
                                  {employee.employee_name}
                                </span>
                                {employee.active && (
                                  <span style={{
                                    fontSize: '11px',
                                    padding: '2px 8px',
                                    borderRadius: '12px',
                                    backgroundColor: '#d4edda',
                                    color: '#155724',
                                    fontWeight: '600'
                                  }}>
                                    ACTIVE
                                  </span>
                                )}
                              </div>
                              {employee.employee_number && (
                                <div style={{ fontSize: '13px', color: '#666' }}>
                                  Employee #{employee.employee_number}
                                </div>
                              )}
                              {employee.notes && (
                                <div style={{
                                  fontSize: '13px',
                                  color: '#666',
                                  marginTop: '8px',
                                  fontStyle: 'italic'
                                }}>
                                  Note: {employee.notes}
                                </div>
                              )}
                            </div>
                          </div>

                          <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'auto 1fr',
                            gap: '8px',
                            fontSize: '13px'
                          }}>
                            {/* DOGE Address */}
                            <div style={{ fontWeight: '600', color: '#BA9F33' }}>DOGE:</div>
                            <div style={{
                              color: employee.doge_address ? '#333' : '#999',
                              fontFamily: employee.doge_address ? 'monospace' : 'inherit',
                              wordBreak: 'break-all'
                            }}>
                              {employee.doge_address || 'Not provided'}
                            </div>

                            {/* BTC Address */}
                            <div style={{ fontWeight: '600', color: '#F7931A' }}>BTC:</div>
                            <div style={{
                              color: employee.btc_address ? '#333' : '#999',
                              fontFamily: employee.btc_address ? 'monospace' : 'inherit',
                              wordBreak: 'break-all'
                            }}>
                              {employee.btc_address || 'Not provided'}
                            </div>

                            {/* LTC Address */}
                            <div style={{ fontWeight: '600', color: '#345D9D' }}>LTC:</div>
                            <div style={{
                              color: employee.ltc_address ? '#333' : '#999',
                              fontFamily: employee.ltc_address ? 'monospace' : 'inherit',
                              wordBreak: 'break-all'
                            }}>
                              {employee.ltc_address || 'Not provided'}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              {/* Modal Footer */}
              <div style={{
                padding: '16px 24px',
                borderTop: '2px solid #e1e8ed',
                display: 'flex',
                justifyContent: 'flex-end'
              }}>
                <button
                  onClick={this.handleCloseEmployeesModal}
                  style={{
                    padding: '10px 24px',
                    backgroundColor: '#6c757d',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '500',
                    transition: 'background-color 0.2s'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#5a6268'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#6c757d'}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default System;
